function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".medium-grey-large-map{fill:#b3b4ae;}.light-grey-large-map{fill:#ecebe6;}.green_dot_light{fill:#9ce0b3;}.font-black{fill:#39474f;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "map_large_1");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Gatehouse_Inside",
  "data-name": "Gatehouse Inside"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "medium-grey-large-map",
  points: "130.45 36.32 260.58 36.32 236.92 11.35 154.5 11.35 130.45 36.32"
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 136.47,
  y: 35.13,
  width: 118.09,
  height: 93.38
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 170.33,
  y: 1.83,
  width: 7.65,
  height: 20.87
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 171.64,
  width: 1.68,
  height: 3.44
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 174.96,
  y: 0.04,
  width: 1.68,
  height: 3.44
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 212.43,
  y: 1.83,
  width: 7.65,
  height: 20.87
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 213.74,
  width: 1.68,
  height: 3.44
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 217.06,
  y: 0.04,
  width: 1.68,
  height: 3.44
}), /*#__PURE__*/React.createElement("polygon", {
  className: "medium-grey-large-map",
  points: "160.08 30.17 195.66 6.05 231.24 30.17 160.08 30.17"
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 219.07,
  y: 43.22,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 235.18,
  y: 43.22,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 147.92,
  y: 43.22,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 164.03,
  y: 43.22,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 184.64,
  y: 43.22,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 198.17,
  y: 43.22,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 184.64,
  y: 71.57,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 198.17,
  y: 71.57,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 219.07,
  y: 71.57,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 235.18,
  y: 71.57,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 147.92,
  y: 71.57,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 164.03,
  y: 71.57,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 189.62,
  y: 99.91,
  width: 11.79,
  height: 26.63
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 219.07,
  y: 99.91,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 235.18,
  y: 99.91,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 147.92,
  y: 99.91,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 164.03,
  y: 99.91,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("polygon", {
  className: "medium-grey-large-map",
  points: "130.45 36.32 260.58 36.32 236.92 11.35 154.5 11.35 130.45 36.32"
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 136.47,
  y: 35.13,
  width: 118.09,
  height: 93.38
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 170.33,
  y: 1.83,
  width: 7.65,
  height: 20.87
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 171.64,
  width: 1.68,
  height: 3.44
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 174.96,
  y: 0.04,
  width: 1.68,
  height: 3.44
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 212.43,
  y: 1.83,
  width: 7.65,
  height: 20.87
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 213.74,
  width: 1.68,
  height: 3.44
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 217.06,
  y: 0.04,
  width: 1.68,
  height: 3.44
}), /*#__PURE__*/React.createElement("polygon", {
  className: "medium-grey-large-map",
  points: "160.08 30.17 195.66 6.05 231.24 30.17 160.08 30.17"
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 219.07,
  y: 43.22,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 235.18,
  y: 43.22,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 147.92,
  y: 43.22,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 164.03,
  y: 43.22,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 184.64,
  y: 43.22,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 198.17,
  y: 43.22,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 184.64,
  y: 71.57,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 198.17,
  y: 71.57,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 219.07,
  y: 71.57,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 235.18,
  y: 71.57,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 147.92,
  y: 71.57,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 164.03,
  y: 71.57,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 189.62,
  y: 99.91,
  width: 11.79,
  height: 26.63
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 219.07,
  y: 99.91,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 235.18,
  y: 99.91,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 147.92,
  y: 99.91,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 164.03,
  y: 99.91,
  width: 8.22,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  y: 120.67,
  width: 309.52,
  height: 38.75
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 47.21,
  y: 92.71,
  width: 48.97,
  height: 27.96
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 45.34,
  y: 88.92,
  width: 52.69,
  height: 5.47
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 44.31,
  y: 93.02,
  width: 54.76,
  height: 1.41
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 44.31,
  y: 87.55,
  width: 54.76,
  height: 1.41
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 254.08,
  y: 91.65,
  width: 43.27,
  height: 5.08
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 254.08,
  y: 80.41,
  width: 13.1,
  height: 13.1
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 272.46,
  y: 84.48,
  width: 6.5,
  height: 9.02
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 278.96,
  y: 88.25,
  width: 9.9,
  height: 5.26
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 293.81,
  y: 89.46,
  width: 7.55,
  height: 1.26
}), /*#__PURE__*/React.createElement("rect", {
  className: "medium-grey-large-map",
  x: 294.34,
  y: 90.72,
  width: 6.5,
  height: 29.95
}), /*#__PURE__*/React.createElement("circle", {
  className: "medium-grey-large-map",
  cx: 297.35,
  cy: 86.26,
  r: 4.04
}), /*#__PURE__*/React.createElement("g", {
  id: "perimeter",
  className: "map_perimeter"
}, /*#__PURE__*/React.createElement("rect", {
  className: "light-grey-large-map",
  x: 6.95,
  y: 96.73,
  width: 40.26,
  height: 23.94
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot_light",
  cx: 27.94,
  cy: 108,
  r: 3.5
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M17.33,109a1.09,1.09,0,0,1-.36.88,1.51,1.51,0,0,1-1,.31h-.32v1.27h-.76v-3.57H16a1.48,1.48,0,0,1,1,.28A1,1,0,0,1,17.33,109Zm-1.71.57h.25a.87.87,0,0,0,.52-.14.51.51,0,0,0,.17-.4.53.53,0,0,0-.14-.4.76.76,0,0,0-.46-.12h-.34Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M19.18,111.46a1.41,1.41,0,0,1-1-.37,1.33,1.33,0,0,1-.37-1,1.47,1.47,0,0,1,.34-1.06A1.4,1.4,0,0,1,20,109a1.27,1.27,0,0,1,.32.91v.36H18.53a.73.73,0,0,0,.19.49.68.68,0,0,0,.49.18,1.85,1.85,0,0,0,.47,0,2.51,2.51,0,0,0,.46-.16v.57a1.5,1.5,0,0,1-.42.15A3.27,3.27,0,0,1,19.18,111.46Zm-.11-2.3a.46.46,0,0,0-.37.15.66.66,0,0,0-.15.42h1a.6.6,0,0,0-.14-.42A.49.49,0,0,0,19.07,109.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M22.42,108.63h.25l-.06.7a.81.81,0,0,0-.22,0,.79.79,0,0,0-.55.19.65.65,0,0,0-.2.51v1.39H20.9v-2.73h.56l.11.46h0a.86.86,0,0,1,.34-.37A.79.79,0,0,1,22.42,108.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M23.13,108c0-.24.14-.36.41-.36s.4.12.4.36a.34.34,0,0,1-.1.27.37.37,0,0,1-.3.1C23.27,108.34,23.13,108.22,23.13,108Zm.78,3.44h-.74v-2.73h.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M27.14,111.41h-.75v-1.6a.75.75,0,0,0-.1-.44.35.35,0,0,0-.31-.15.46.46,0,0,0-.41.21,1.35,1.35,0,0,0-.13.69v1.29h-.75v-2.73h.57l.1.35h0a.84.84,0,0,1,.32-.3,1.12,1.12,0,0,1,.48-.1.87.87,0,0,1,.83.4h.06a.74.74,0,0,1,.33-.3,1.12,1.12,0,0,1,.48-.1,1,1,0,0,1,.7.23,1.08,1.08,0,0,1,.24.77v1.78h-.75v-1.6a.75.75,0,0,0-.1-.44.35.35,0,0,0-.31-.15.47.47,0,0,0-.41.2,1.12,1.12,0,0,0-.13.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M30.84,111.46a1.41,1.41,0,0,1-1-.37,1.33,1.33,0,0,1-.37-1,1.47,1.47,0,0,1,.34-1.06,1.39,1.39,0,0,1,1.85,0,1.27,1.27,0,0,1,.32.91v.36H30.19a.73.73,0,0,0,.19.49.68.68,0,0,0,.49.18,1.85,1.85,0,0,0,.47,0,2.51,2.51,0,0,0,.46-.16v.57a1.5,1.5,0,0,1-.42.15A3.33,3.33,0,0,1,30.84,111.46Zm-.11-2.3a.46.46,0,0,0-.37.15.66.66,0,0,0-.15.42h1a.6.6,0,0,0-.14-.42A.49.49,0,0,0,30.73,109.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M33.71,110.86a1.77,1.77,0,0,0,.46-.08v.55a1.79,1.79,0,0,1-.68.13.82.82,0,0,1-.65-.23,1,1,0,0,1-.2-.68v-1.31h-.36v-.32l.41-.25.21-.57h.48v.58h.76v.56h-.76v1.31a.3.3,0,0,0,.09.24A.34.34,0,0,0,33.71,110.86Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M36,111.46a1.41,1.41,0,0,1-1-.37,1.33,1.33,0,0,1-.37-1A1.52,1.52,0,0,1,34.9,109a1.46,1.46,0,0,1,1.9,0,1.23,1.23,0,0,1,.32.91v.36H35.31a.75.75,0,0,0,.19.49.66.66,0,0,0,.5.18,2.4,2.4,0,0,0,.46,0,2.51,2.51,0,0,0,.46-.16v.57a1.5,1.5,0,0,1-.42.15A2.79,2.79,0,0,1,36,111.46Zm-.1-2.3a.46.46,0,0,0-.37.15.67.67,0,0,0-.16.42h1.05a.66.66,0,0,0-.15-.42.48.48,0,0,0-.41-.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M39.2,108.63h.26l-.06.7a1.26,1.26,0,0,0-.78.19.69.69,0,0,0-.19.51v1.39h-.75v-2.73h.56l.11.46h0a1,1,0,0,1,.34-.37A.79.79,0,0,1,39.2,108.63Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "gatehouse",
  className: "map_gatehouse"
}, /*#__PURE__*/React.createElement("rect", {
  className: "light-grey-large-map",
  x: 51.56,
  y: 96.73,
  width: 40.26,
  height: 23.94
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot_light",
  cx: 72.27,
  cy: 108,
  r: 3.5
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M60.06,109.11h1.41V111a3.53,3.53,0,0,1-.64.16,3.32,3.32,0,0,1-.63,0,1.58,1.58,0,0,1-1.23-.48,2,2,0,0,1-.43-1.36A1.83,1.83,0,0,1,59,108a1.86,1.86,0,0,1,1.37-.48,2.58,2.58,0,0,1,1.06.22l-.25.6a1.8,1.8,0,0,0-.82-.19,1,1,0,0,0-.78.33,1.23,1.23,0,0,0-.3.88,1.4,1.4,0,0,0,.24.89.83.83,0,0,0,.69.31h.48v-.75H60Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M64,111.12l-.15-.37h0a1.18,1.18,0,0,1-.38.32,1.15,1.15,0,0,1-.52.1.84.84,0,0,1-.62-.23.87.87,0,0,1-.23-.64.74.74,0,0,1,.31-.64,1.71,1.71,0,0,1,.91-.23h.48v-.12a.37.37,0,0,0-.31-.42.24.24,0,0,0-.12,0,1.87,1.87,0,0,0-.77.2l-.24-.5a2.18,2.18,0,0,1,1-.25,1.26,1.26,0,0,1,.84.24.88.88,0,0,1,.3.73v1.82Zm-.22-1.27h-.29A1.08,1.08,0,0,0,63,110a.36.36,0,0,0-.16.33c0,.21.12.31.36.31a.56.56,0,0,0,.41-.15.48.48,0,0,0,.16-.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M66.43,110.57a1.85,1.85,0,0,0,.47-.08V111a1.79,1.79,0,0,1-.68.13.82.82,0,0,1-.65-.23,1,1,0,0,1-.2-.68V109H65v-.32l.41-.25.21-.57h.48v.58h.76V109H66.1v1.31a.3.3,0,0,0,.09.24A.4.4,0,0,0,66.43,110.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M68.69,111.17a1.41,1.41,0,0,1-1-.37,1.33,1.33,0,0,1-.37-1,1.47,1.47,0,0,1,.34-1.06,1.46,1.46,0,0,1,1.9,0,1.23,1.23,0,0,1,.32.91V110H68a.73.73,0,0,0,.19.49.68.68,0,0,0,.49.18,1.85,1.85,0,0,0,.47,0,2.51,2.51,0,0,0,.46-.16V111a1.5,1.5,0,0,1-.42.15A2.79,2.79,0,0,1,68.69,111.17Zm-.1-2.3a.5.5,0,0,0-.38.15.66.66,0,0,0-.15.42h1A.67.67,0,0,0,69,109,.48.48,0,0,0,68.59,108.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M72.93,111.12h-.75v-1.6c0-.39-.14-.59-.44-.59a.52.52,0,0,0-.45.21,1.26,1.26,0,0,0-.14.69v1.29h-.74v-3.8h.74v1.42h0a.84.84,0,0,1,.79-.4,1,1,0,0,1,.73.25,1,1,0,0,1,.25.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M76.18,109.75a1.47,1.47,0,0,1-.36,1,1.25,1.25,0,0,1-1,.38,1.39,1.39,0,0,1-.69-.18,1.09,1.09,0,0,1-.46-.49,1.61,1.61,0,0,1-.16-.75,1.46,1.46,0,0,1,.35-1,1.52,1.52,0,0,1,1.69-.2A1,1,0,0,1,76,109,1.63,1.63,0,0,1,76.18,109.75Zm-1.89,0a1.18,1.18,0,0,0,.13.61.49.49,0,0,0,.43.21.46.46,0,0,0,.43-.21,1.18,1.18,0,0,0,.13-.61,1.09,1.09,0,0,0-.13-.61.56.56,0,0,0-.79-.07h0a.23.23,0,0,0-.07.07A1.09,1.09,0,0,0,74.29,109.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M78.72,111.12l-.1-.35h0a1.05,1.05,0,0,1-.34.29,1.25,1.25,0,0,1-.5.11,1,1,0,0,1-.73-.26,1,1,0,0,1-.24-.74v-1.78h.74V110a.76.76,0,0,0,.11.44.39.39,0,0,0,.33.15.47.47,0,0,0,.45-.21,1.26,1.26,0,0,0,.14-.69v-1.28h.75v2.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M82,110.31a.79.79,0,0,1-.29.64,1.47,1.47,0,0,1-.87.22,4.34,4.34,0,0,1-.51,0,2.91,2.91,0,0,1-.39-.12v-.62a1.93,1.93,0,0,0,.46.16,1.77,1.77,0,0,0,.46.07c.27,0,.41-.08.41-.23a.2.2,0,0,0-.06-.15l-.18-.12-.35-.16a2.12,2.12,0,0,1-.47-.25.64.64,0,0,1-.21-.25.89.89,0,0,1-.07-.36.64.64,0,0,1,.28-.57,1.4,1.4,0,0,1,.8-.19,2.3,2.3,0,0,1,1,.21l-.22.54L81.4,109a1.09,1.09,0,0,0-.36,0q-.33,0-.33.18a.25.25,0,0,0,.11.17,2.77,2.77,0,0,0,.46.22,1.4,1.4,0,0,1,.47.24.78.78,0,0,1,.22.26A.5.5,0,0,1,82,110.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M83.8,111.17a1.41,1.41,0,0,1-1-.37,1.33,1.33,0,0,1-.37-1,1.47,1.47,0,0,1,.34-1.06,1.39,1.39,0,0,1,1.85,0,1.27,1.27,0,0,1,.32.91V110H83.15a.73.73,0,0,0,.19.49.68.68,0,0,0,.49.18,1.85,1.85,0,0,0,.47,0,2.51,2.51,0,0,0,.46-.16V111a1.5,1.5,0,0,1-.42.15A3.25,3.25,0,0,1,83.8,111.17Zm-.11-2.3a.46.46,0,0,0-.37.15.66.66,0,0,0-.15.42h1A.61.61,0,0,0,84,109,.49.49,0,0,0,83.69,108.87Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "exterior_front",
  className: "map_exterior_front",
  "data-name": "exterior front"
}, /*#__PURE__*/React.createElement("rect", {
  className: "light-grey-large-map",
  x: 96.17,
  y: 96.73,
  width: 40.26,
  height: 23.94
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot_light",
  cx: 116.73,
  cy: 108,
  r: 3.5
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M101,106.52H99V103h2v.62H99.7v.78h1.21v.6H99.73v.92H101Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M102.28,105.12l-.88-1.33h.84l.53.87.54-.87h.84l-.89,1.33.93,1.4h-.84l-.58-.94-.57.94h-.85Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M105.76,106a1.85,1.85,0,0,0,.47-.08v.55a1.8,1.8,0,0,1-.69.13.87.87,0,0,1-.65-.23,1,1,0,0,1-.2-.68v-1.31h-.36V104l.41-.25.22-.57h.47v.58h.77v.56h-.77v1.31a.3.3,0,0,0,.09.24A.38.38,0,0,0,105.76,106Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M108,106.57a1.28,1.28,0,0,1-1.4-1.15h0a1,1,0,0,1,0-.25,1.51,1.51,0,0,1,.35-1.06,1.19,1.19,0,0,1,.94-.37,1.21,1.21,0,0,1,.91.33,1.27,1.27,0,0,1,.32.91v.36h-1.76a.69.69,0,0,0,.19.49.64.64,0,0,0,.49.18,2.4,2.4,0,0,0,.46-.05,2.51,2.51,0,0,0,.46-.16v.57a1.56,1.56,0,0,1-.41.15A3.41,3.41,0,0,1,108,106.57Zm-.1-2.3a.46.46,0,0,0-.37.15.73.73,0,0,0-.16.42h1a.6.6,0,0,0-.14-.42.51.51,0,0,0-.37-.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M111.26,103.74h.25l-.06.7h-.22a.74.74,0,0,0-.55.19.65.65,0,0,0-.2.51v1.39h-.75V103.8h.57l.11.46h0a1,1,0,0,1,.35-.37A.74.74,0,0,1,111.26,103.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M112,103.08c0-.24.14-.36.41-.36s.4.12.4.36a.34.34,0,0,1-.1.27.41.41,0,0,1-.3.1C112.11,103.45,112,103.33,112,103.08Zm.78,3.44H112v-2.73h.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M116,105.15a1.46,1.46,0,0,1-.35,1,1.29,1.29,0,0,1-1,.38,1.39,1.39,0,0,1-.69-.18,1.11,1.11,0,0,1-.47-.49,1.78,1.78,0,0,1-.16-.75,1.46,1.46,0,0,1,.35-1,1.28,1.28,0,0,1,1-.37,1.32,1.32,0,0,1,.7.17,1.09,1.09,0,0,1,.46.49A1.61,1.61,0,0,1,116,105.15Zm-1.89,0a1.19,1.19,0,0,0,.14.61.46.46,0,0,0,.43.21.49.49,0,0,0,.43-.21,1.52,1.52,0,0,0,0-1.22.48.48,0,0,0-.44-.2.46.46,0,0,0-.43.2,1.28,1.28,0,0,0-.12.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M118.15,103.74h.25l-.06.7h-.22a.79.79,0,0,0-.55.19.65.65,0,0,0-.2.51v1.39h-.74V103.8h.56l.11.46h0a.86.86,0,0,1,.34-.37A.79.79,0,0,1,118.15,103.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M121.7,104.35h-.64v2.17h-.75v-2.17h-.41V104l.41-.2v-.2a.89.89,0,0,1,.23-.68,1,1,0,0,1,.74-.22,2,2,0,0,1,.68.12l-.19.54a1.85,1.85,0,0,0-.41-.07.25.25,0,0,0-.23.1.34.34,0,0,0-.07.24v.17h.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M123.65,103.74h.26l-.06.7h-.22a.83.83,0,0,0-.56.19.69.69,0,0,0-.19.51v1.39h-.75V103.8h.56l.11.46h0a1,1,0,0,1,.34-.37A.79.79,0,0,1,123.65,103.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M126.88,105.15a1.46,1.46,0,0,1-.35,1,1.25,1.25,0,0,1-1,.38,1.39,1.39,0,0,1-.69-.18,1.09,1.09,0,0,1-.46-.49,1.61,1.61,0,0,1-.16-.75,1.31,1.31,0,0,1,2-1.2,1.09,1.09,0,0,1,.46.49A1.5,1.5,0,0,1,126.88,105.15Zm-1.89,0a1.19,1.19,0,0,0,.14.61.54.54,0,0,0,.76.1h0l.09-.09a1.52,1.52,0,0,0,0-1.22.46.46,0,0,0-.43-.2.45.45,0,0,0-.43.2,1.09,1.09,0,0,0-.13.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M130,106.52h-.75v-1.6a.75.75,0,0,0-.1-.44.38.38,0,0,0-.34-.15.47.47,0,0,0-.45.21,1.26,1.26,0,0,0-.14.69v1.29h-.74v-2.73h.57l.1.35h0a.76.76,0,0,1,.34-.3,1.24,1.24,0,0,1,.5-.1,1,1,0,0,1,.72.25,1.08,1.08,0,0,1,.25.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M131.93,106a1.85,1.85,0,0,0,.47-.08v.55a1.79,1.79,0,0,1-.68.13.82.82,0,0,1-.65-.23,1,1,0,0,1-.21-.68v-1.31h-.35V104l.41-.25.21-.57h.48v.58h.76v.56h-.76v1.31a.3.3,0,0,0,.09.24A.36.36,0,0,0,131.93,106Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M132.85,104.15a.4.4,0,0,1,.11-.31.46.46,0,0,1,.32-.1.45.45,0,0,1,.31.1.48.48,0,0,1,0,.62.51.51,0,0,1-.31.11.42.42,0,0,1-.32-.11A.4.4,0,0,1,132.85,104.15Zm0,2a.4.4,0,0,1,.11-.31.42.42,0,0,1,.32-.11.38.38,0,0,1,.42.34v.08a.38.38,0,0,1-.11.3.4.4,0,0,1-.31.11.42.42,0,0,1-.32-.11.43.43,0,0,1-.11-.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M107.46,111.51h1.41v1.85a3.53,3.53,0,0,1-.64.16,3.31,3.31,0,0,1-.63,0,1.58,1.58,0,0,1-1.23-.48,2,2,0,0,1-.43-1.36,1.78,1.78,0,0,1,.5-1.35,1.86,1.86,0,0,1,1.37-.48,2.58,2.58,0,0,1,1.06.22l-.25.6a1.8,1.8,0,0,0-.82-.19,1,1,0,0,0-.78.33,1.23,1.23,0,0,0-.3.88,1.4,1.4,0,0,0,.24.89.83.83,0,0,0,.69.31,3.84,3.84,0,0,0,.48,0v-.75h-.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M111.19,110.74h.25l-.06.7h-.22a.79.79,0,0,0-.55.19.65.65,0,0,0-.2.51v1.39h-.75V110.8h.57l.11.46h0a.86.86,0,0,1,.34-.37A.79.79,0,0,1,111.19,110.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M114.42,112.15a1.47,1.47,0,0,1-.36,1,1.25,1.25,0,0,1-1,.38,1.31,1.31,0,0,1-.7-.18,1.09,1.09,0,0,1-.46-.49,1.61,1.61,0,0,1-.16-.75,1.46,1.46,0,0,1,.35-1,1.52,1.52,0,0,1,1.69-.2,1,1,0,0,1,.46.49A1.63,1.63,0,0,1,114.42,112.15Zm-1.89,0a1.18,1.18,0,0,0,.13.61.49.49,0,0,0,.43.21.46.46,0,0,0,.43-.21,1.52,1.52,0,0,0,0-1.22.56.56,0,0,0-.79-.07h0l-.07.07A1.09,1.09,0,0,0,112.53,112.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M117,113.52l-.1-.35h0a.74.74,0,0,1-.34.29,1.25,1.25,0,0,1-.5.11,1,1,0,0,1-.73-.26,1,1,0,0,1-.24-.74v-1.78h.74v1.59a.76.76,0,0,0,.11.44.39.39,0,0,0,.33.15.47.47,0,0,0,.45-.21,1.26,1.26,0,0,0,.14-.69v-1.28h.75v2.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M120.84,113.52h-.75v-1.6a.75.75,0,0,0-.1-.44.38.38,0,0,0-.34-.15.47.47,0,0,0-.45.21,1.26,1.26,0,0,0-.14.69v1.29h-.74v-2.73h.57l.1.35h0a.76.76,0,0,1,.34-.3,1.24,1.24,0,0,1,.5-.1,1,1,0,0,1,.72.25,1.08,1.08,0,0,1,.25.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M122.47,113.57a1,1,0,0,1-.76-.38,2,2,0,0,1,0-2,.88.88,0,0,1,.77-.37.9.9,0,0,1,.78.4h0a2.57,2.57,0,0,1-.06-.55v-.87H124v3.8h-.57l-.15-.36h0A.85.85,0,0,1,122.47,113.57Zm.26-.6a.51.51,0,0,0,.42-.16,1,1,0,0,0,.14-.57v-.08a1.14,1.14,0,0,0-.13-.63.53.53,0,0,0-.44-.19.42.42,0,0,0-.39.21,1.2,1.2,0,0,0-.14.62,1,1,0,0,0,.14.6.44.44,0,0,0,.4.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M126.67,112.71a.79.79,0,0,1-.29.64,1.47,1.47,0,0,1-.87.22,4.34,4.34,0,0,1-.51,0,2.91,2.91,0,0,1-.39-.12v-.62a2.54,2.54,0,0,0,.46.17,1.76,1.76,0,0,0,.46.06c.27,0,.41-.08.41-.23a.2.2,0,0,0-.06-.15.57.57,0,0,0-.18-.12l-.35-.16a2.12,2.12,0,0,1-.47-.25.64.64,0,0,1-.21-.25.89.89,0,0,1-.07-.36.66.66,0,0,1,.28-.56,1.33,1.33,0,0,1,.8-.2,2.3,2.3,0,0,1,1,.21l-.22.54-.39-.15a1.09,1.09,0,0,0-.36,0q-.33,0-.33.18a.25.25,0,0,0,.11.17,2.77,2.77,0,0,0,.46.22,1.4,1.4,0,0,1,.47.24.78.78,0,0,1,.22.26A.57.57,0,0,1,126.67,112.71Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "reception",
  className: "map_reception"
}, /*#__PURE__*/React.createElement("rect", {
  className: "light-grey-large-map",
  x: 140.79,
  y: 96.73,
  width: 40.26,
  height: 23.94
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot_light",
  cx: 160,
  cy: 108,
  r: 3.5
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M149.66,109.89v1.37h-.76v-3.57h1a1.79,1.79,0,0,1,1.1.31,1,1,0,0,1,.17,1.36,1.11,1.11,0,0,1-.49.39l1,1.55h-.84l-.85-1.37Zm0-.61h.24a1,1,0,0,0,.53-.12.43.43,0,0,0,.17-.38.4.4,0,0,0-.17-.36,1.12,1.12,0,0,0-.54-.11h-.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M153.38,111.31a1.27,1.27,0,0,1-1.38-1.13V110a1.47,1.47,0,0,1,.34-1.06,1.39,1.39,0,0,1,1.85,0,1.27,1.27,0,0,1,.32.91v.36h-1.76a.78.78,0,0,0,.19.5.68.68,0,0,0,.49.18,1.85,1.85,0,0,0,.47,0,2.54,2.54,0,0,0,.46-.17v.58a1.88,1.88,0,0,1-.42.14A1.83,1.83,0,0,1,153.38,111.31Zm-.11-2.3a.46.46,0,0,0-.37.15.66.66,0,0,0-.15.43h1a.6.6,0,0,0-.14-.43.5.5,0,0,0-.34-.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M156.2,111.31c-.85,0-1.27-.47-1.27-1.4a1.45,1.45,0,0,1,.35-1.06,1.28,1.28,0,0,1,1-.37,1.79,1.79,0,0,1,.85.19l-.22.57-.33-.11a.76.76,0,0,0-.3,0c-.39,0-.58.28-.58.83s.19.8.58.8a1.34,1.34,0,0,0,.4-.06,1.22,1.22,0,0,0,.36-.18v.64a1.46,1.46,0,0,1-.36.16A1.93,1.93,0,0,1,156.2,111.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M158.9,111.31a1.47,1.47,0,0,1-1-.36,1.37,1.37,0,0,1-.37-1,1.57,1.57,0,0,1,.34-1.06,1.22,1.22,0,0,1,.95-.38,1.14,1.14,0,0,1,1.23,1,.67.67,0,0,1,0,.2v.36h-1.76a.72.72,0,0,0,.18.5.66.66,0,0,0,.5.18,2.4,2.4,0,0,0,.46-.05,2.54,2.54,0,0,0,.46-.17v.58a1.88,1.88,0,0,1-.42.14A2.18,2.18,0,0,1,158.9,111.31Zm-.1-2.3a.46.46,0,0,0-.37.15.73.73,0,0,0-.16.43h1a.61.61,0,0,0-.15-.43.49.49,0,0,0-.32-.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M162.12,111.31a.91.91,0,0,1-.75-.35h0v1.5h-.75v-3.93h.61l.1.36h0a.86.86,0,0,1,.77-.41.91.91,0,0,1,.76.37,1.77,1.77,0,0,1,.27,1,2,2,0,0,1-.13.76A1.08,1.08,0,0,1,162.12,111.31Zm-.22-2.23a.45.45,0,0,0-.4.17.91.91,0,0,0-.13.56v.08a1.14,1.14,0,0,0,.13.63.48.48,0,0,0,.41.19c.33,0,.5-.28.5-.83a1.24,1.24,0,0,0-.12-.6A.43.43,0,0,0,161.9,109.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M164.93,110.72a1.27,1.27,0,0,0,.47-.09v.56a1.6,1.6,0,0,1-.68.12.86.86,0,0,1-.65-.22,1,1,0,0,1-.2-.68v-1.32h-.36v-.31l.41-.25.21-.58h.48v.58h.76v.56h-.76v1.32a.28.28,0,0,0,.09.23A.4.4,0,0,0,164.93,110.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M165.92,107.83c0-.25.14-.37.41-.37s.4.12.4.37a.34.34,0,0,1-.1.27.4.4,0,0,1-.3.09C166.06,108.19,165.92,108.07,165.92,107.83Zm.78,3.43H166v-2.73h.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M170,109.89a1.46,1.46,0,0,1-.35,1,1.25,1.25,0,0,1-1,.38,1.5,1.5,0,0,1-.69-.17,1.17,1.17,0,0,1-.46-.5,1.61,1.61,0,0,1-.16-.75,1.52,1.52,0,0,1,.34-1,1.28,1.28,0,0,1,1-.37,1.5,1.5,0,0,1,.69.17,1.2,1.2,0,0,1,.46.49A1.75,1.75,0,0,1,170,109.89Zm-1.89,0a1.2,1.2,0,0,0,.14.62.56.56,0,0,0,.79.07h0a.23.23,0,0,0,.07-.07,1.22,1.22,0,0,0,.13-.62,1.18,1.18,0,0,0-.13-.61.48.48,0,0,0-.43-.2.46.46,0,0,0-.43.2,1.09,1.09,0,0,0-.18.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M173.1,111.26h-.75v-1.59a.79.79,0,0,0-.1-.45.4.4,0,0,0-.34-.14.47.47,0,0,0-.45.21,1.26,1.26,0,0,0-.14.69v1.28h-.74v-2.73h.57l.1.35h0a.76.76,0,0,1,.34-.3,1.24,1.24,0,0,1,.5-.1,1,1,0,0,1,.72.26,1,1,0,0,1,.25.74Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "meeting_room",
  className: "map_meeting_room",
  "data-name": "meeting room"
}, /*#__PURE__*/React.createElement("rect", {
  className: "light-grey-large-map",
  x: 209.47,
  y: 96.73,
  width: 40.26,
  height: 23.94
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot_light",
  cx: 230,
  cy: 108,
  r: 3.5
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M221.11,106.52l-.86-2.8h0c0,.57.05,1,.05,1.14v1.66h-.68V103h1l.84,2.73h0l.89-2.73h1v3.57h-.7v-2.83h0l-.92,2.8Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M225.49,106.57a1.37,1.37,0,0,1-1-.37,1.33,1.33,0,0,1-.37-1,1.47,1.47,0,0,1,.34-1.06,1.24,1.24,0,0,1,.95-.37,1.2,1.2,0,0,1,.9.33,1.23,1.23,0,0,1,.32.91v.36h-1.76a.69.69,0,0,0,.19.49.68.68,0,0,0,.49.18H226a2.51,2.51,0,0,0,.46-.16v.57a1.5,1.5,0,0,1-.42.15A3.38,3.38,0,0,1,225.49,106.57Zm-.1-2.3a.5.5,0,0,0-.38.15.66.66,0,0,0-.15.42h1a.66.66,0,0,0-.15-.42A.48.48,0,0,0,225.39,104.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M228.44,106.57a1.28,1.28,0,0,1-1.4-1.15h0a1,1,0,0,1,0-.25,1.51,1.51,0,0,1,.35-1.06,1.19,1.19,0,0,1,.94-.37,1.21,1.21,0,0,1,.91.33,1.27,1.27,0,0,1,.32.91v.36H227.8a.69.69,0,0,0,.19.49.64.64,0,0,0,.49.18,2.4,2.4,0,0,0,.46-.05,2.51,2.51,0,0,0,.46-.16v.57a1.56,1.56,0,0,1-.41.15A3.41,3.41,0,0,1,228.44,106.57Zm-.1-2.3a.46.46,0,0,0-.37.15.73.73,0,0,0-.16.42h1.05a.6.6,0,0,0-.14-.42A.5.5,0,0,0,228.34,104.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M231.31,106a1.85,1.85,0,0,0,.47-.08v.55a1.79,1.79,0,0,1-.68.13.82.82,0,0,1-.65-.23,1,1,0,0,1-.21-.68v-1.31h-.35V104l.41-.25.21-.57H231v.58h.76v.56H231v1.31a.3.3,0,0,0,.09.24A.32.32,0,0,0,231.31,106Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M232.3,103.08c0-.24.14-.36.41-.36s.4.12.4.36a.34.34,0,0,1-.1.27.41.41,0,0,1-.3.1C232.44,103.45,232.3,103.33,232.3,103.08Zm.78,3.44h-.75v-2.73h.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M236.38,106.52h-.75v-1.6a.75.75,0,0,0-.1-.44.38.38,0,0,0-.34-.15.52.52,0,0,0-.45.21,1.26,1.26,0,0,0-.14.69v1.29h-.74v-2.73h.57l.1.35h0a.83.83,0,0,1,.34-.3,1.24,1.24,0,0,1,.5-.1,1,1,0,0,1,.72.25,1,1,0,0,1,.25.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M239.52,103.79v.38l-.43.11a.73.73,0,0,1,.12.41.82.82,0,0,1-.31.68,1.31,1.31,0,0,1-.85.25h-.24a.25.25,0,0,0-.12.19c0,.11.14.16.41.16h.47a1,1,0,0,1,.68.2.65.65,0,0,1,.24.56.82.82,0,0,1-.4.74,2.1,2.1,0,0,1-1.15.27,1.55,1.55,0,0,1-.87-.2.63.63,0,0,1-.3-.56.61.61,0,0,1,.15-.41,1,1,0,0,1,.45-.24.45.45,0,0,1-.2-.16.4.4,0,0,1-.08-.23.41.41,0,0,1,.09-.26,1.33,1.33,0,0,1,.26-.21.74.74,0,0,1-.34-.29,1.05,1.05,0,0,1-.13-.49.83.83,0,0,1,.29-.69,1.29,1.29,0,0,1,.83-.24,1.31,1.31,0,0,1,.28,0h.2Zm-2.11,3.11a.28.28,0,0,0,.15.24.76.76,0,0,0,.42.09,1.34,1.34,0,0,0,.62-.11.33.33,0,0,0,.23-.3.23.23,0,0,0-.13-.21,1,1,0,0,0-.42-.06h-.39a.52.52,0,0,0-.34.1A.29.29,0,0,0,237.41,106.9Zm.27-2.22a.49.49,0,0,0,.11.35.34.34,0,0,0,.3.13.37.37,0,0,0,.31-.13.55.55,0,0,0,.1-.35c0-.33-.13-.49-.41-.49S237.68,104.35,237.68,104.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M223.37,112.15v1.37h-.76V110h1a1.78,1.78,0,0,1,1.08.26,1,1,0,0,1,.35.81,1,1,0,0,1-.17.56,1.17,1.17,0,0,1-.5.38l1,1.56h-.84l-.85-1.37Zm0-.62h.24a1,1,0,0,0,.53-.12.38.38,0,0,0,.17-.37.38.38,0,0,0-.17-.36,1,1,0,0,0-.54-.11h-.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M228.34,112.15a1.47,1.47,0,0,1-.36,1,1.25,1.25,0,0,1-1,.38,1.39,1.39,0,0,1-.69-.18,1.09,1.09,0,0,1-.46-.49,1.61,1.61,0,0,1-.16-.75,1.41,1.41,0,0,1,.35-1,1.52,1.52,0,0,1,1.69-.2,1,1,0,0,1,.46.49A1.5,1.5,0,0,1,228.34,112.15Zm-1.89,0a1.18,1.18,0,0,0,.13.61.49.49,0,0,0,.43.21.46.46,0,0,0,.43-.21,1.52,1.52,0,0,0,0-1.22.56.56,0,0,0-.79-.07h0a.23.23,0,0,0-.07.07A1.09,1.09,0,0,0,226.45,112.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M231.43,112.15a1.46,1.46,0,0,1-.35,1,1.29,1.29,0,0,1-1,.38,1.39,1.39,0,0,1-.69-.18,1.09,1.09,0,0,1-.46-.49,1.75,1.75,0,0,1-.17-.75,1.46,1.46,0,0,1,.35-1,1.52,1.52,0,0,1,1.69-.2,1.09,1.09,0,0,1,.46.49A1.5,1.5,0,0,1,231.43,112.15Zm-1.89,0a1.19,1.19,0,0,0,.14.61.54.54,0,0,0,.76.1h0l.09-.09a1.52,1.52,0,0,0,0-1.22.46.46,0,0,0-.43-.2.45.45,0,0,0-.43.2A1.19,1.19,0,0,0,229.54,112.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M234.49,113.52h-.74v-1.6a.86.86,0,0,0-.1-.44.35.35,0,0,0-.31-.15.46.46,0,0,0-.42.21,1.35,1.35,0,0,0-.13.69v1.29h-.74v-2.73h.57l.1.35h0a.75.75,0,0,1,.31-.3,1.12,1.12,0,0,1,.48-.1.87.87,0,0,1,.83.4h.07a.67.67,0,0,1,.32-.3,1.12,1.12,0,0,1,.48-.1,1,1,0,0,1,.7.23,1.08,1.08,0,0,1,.24.77v1.78h-.75v-1.6a.85.85,0,0,0-.09-.44.36.36,0,0,0-.32-.15.46.46,0,0,0-.4.2,1,1,0,0,0-.14.62Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "garage",
  className: "map_garage"
}, /*#__PURE__*/React.createElement("rect", {
  className: "light-grey-large-map",
  x: 140.79,
  y: 125.02,
  width: 40.26,
  height: 23.94
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot_light",
  cx: 160,
  cy: 138,
  r: 3.5
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M153.91,136.48h1.42v1.86a3.61,3.61,0,0,1-.65.15,3.21,3.21,0,0,1-.62,0,1.6,1.6,0,0,1-1.24-.48,2,2,0,0,1-.42-1.36,1.81,1.81,0,0,1,.49-1.35,1.86,1.86,0,0,1,1.37-.48,2.58,2.58,0,0,1,1.06.22l-.25.6a1.75,1.75,0,0,0-.81-.19,1,1,0,0,0-.79.33,1.22,1.22,0,0,0-.29.88,1.47,1.47,0,0,0,.23.89.83.83,0,0,0,.7.31h.48v-.75h-.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M157.85,138.49l-.14-.37h0a1.13,1.13,0,0,1-.39.33,1.14,1.14,0,0,1-.52.09.77.77,0,0,1-.84-.71.43.43,0,0,1,0-.16.7.7,0,0,1,.3-.64,2,2,0,0,1,.92-.23h.47v-.12c0-.28-.14-.41-.42-.41a1.86,1.86,0,0,0-.77.19l-.25-.5a2.18,2.18,0,0,1,1-.25,1.31,1.31,0,0,1,.84.24.92.92,0,0,1,.29.73v1.82Zm-.22-1.27h-.29a1,1,0,0,0-.48.12.36.36,0,0,0-.16.33c0,.21.12.31.36.31a.6.6,0,0,0,.42-.15.51.51,0,0,0,.15-.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M160.66,135.71h.25v.7h-.22a.83.83,0,0,0-.56.19.65.65,0,0,0-.2.51v1.39h-.74v-2.73h.56l.11.46h0a1,1,0,0,1,.34-.37A1,1,0,0,1,160.66,135.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M163.14,138.49l-.14-.37h0a1.13,1.13,0,0,1-.39.33,1.14,1.14,0,0,1-.52.09.77.77,0,0,1-.84-.71.43.43,0,0,1,0-.16.7.7,0,0,1,.3-.64,2,2,0,0,1,.92-.23h.47v-.12c0-.28-.14-.41-.42-.41a1.86,1.86,0,0,0-.77.19l-.25-.5a2.29,2.29,0,0,1,1.05-.25,1.31,1.31,0,0,1,.84.24.92.92,0,0,1,.29.73v1.82Zm-.22-1.27h-.29a1,1,0,0,0-.48.12.36.36,0,0,0-.16.33c0,.21.12.31.36.31a.59.59,0,0,0,.42-.15.51.51,0,0,0,.15-.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M166.8,135.76v.38l-.42.11a.87.87,0,0,1,.11.41.85.85,0,0,1-.3.68,1.31,1.31,0,0,1-.85.25h-.25a.27.27,0,0,0-.11.19c0,.11.13.17.41.17h.46a1.05,1.05,0,0,1,.69.19.7.7,0,0,1,.23.56.85.85,0,0,1-.4.75,2.15,2.15,0,0,1-1.14.26,1.59,1.59,0,0,1-.88-.2.63.63,0,0,1-.3-.56.57.57,0,0,1,.16-.41.86.86,0,0,1,.45-.24.45.45,0,0,1-.2-.16.32.32,0,0,1-.09-.23.41.41,0,0,1,.09-.26,1.33,1.33,0,0,1,.26-.21.74.74,0,0,1-.34-.29,1,1,0,0,1-.12-.49.83.83,0,0,1,.29-.69,1.23,1.23,0,0,1,.83-.24h.47Zm-2.1,3.11a.29.29,0,0,0,.14.25.88.88,0,0,0,.42.08,1.5,1.5,0,0,0,.63-.11.31.31,0,0,0,.22-.3.21.21,0,0,0-.13-.21,1,1,0,0,0-.42-.06h-.38a.62.62,0,0,0-.35.1A.31.31,0,0,0,164.7,138.87Zm.27-2.22a.55.55,0,0,0,.1.35.43.43,0,0,0,.61,0h0a.54.54,0,0,0,.09-.35c0-.33-.13-.49-.4-.49s-.38.16-.38.49Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M168.49,138.54a1.37,1.37,0,0,1-1-.37,1.33,1.33,0,0,1-.37-1,1.57,1.57,0,0,1,.34-1.06,1.39,1.39,0,0,1,1.85,0,1.27,1.27,0,0,1,.32.91v.36h-1.76a.78.78,0,0,0,.19.5.69.69,0,0,0,.49.17,1.85,1.85,0,0,0,.47,0,2.51,2.51,0,0,0,.46-.16v.57a1.5,1.5,0,0,1-.42.15A2.78,2.78,0,0,1,168.49,138.54Zm-.11-2.3a.48.48,0,0,0-.37.15.66.66,0,0,0-.15.42h1a.6.6,0,0,0-.14-.42.49.49,0,0,0-.34-.15Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "basement",
  className: "map_basement"
}, /*#__PURE__*/React.createElement("rect", {
  className: "light-grey-large-map",
  x: 209.47,
  y: 125.02,
  width: 40.26,
  height: 23.94
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot_light",
  cx: 230,
  cy: 138,
  r: 3.5
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M217.61,128.38h1.11a2.19,2.19,0,0,1,1.1.21.76.76,0,0,1,.35.69.91.91,0,0,1-.15.53.64.64,0,0,1-.4.24h0a.79.79,0,0,1,.49.28,1,1,0,0,1-.21,1.31,1.48,1.48,0,0,1-1,.28h-1.34Zm.76,1.41h.44a.85.85,0,0,0,.44-.09.37.37,0,0,0,.14-.32.31.31,0,0,0-.15-.29,1,1,0,0,0-.48-.09h-.39Zm0,.6v.93h.49a.76.76,0,0,0,.46-.12.44.44,0,0,0,.15-.36q0-.45-.63-.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M222.64,132l-.14-.37h0a1.34,1.34,0,0,1-.39.32,1,1,0,0,1-.52.1.79.79,0,0,1-.84-.73v-.14a.7.7,0,0,1,.3-.64,1.75,1.75,0,0,1,.92-.23h.47v-.12a.37.37,0,0,0-.31-.42.21.21,0,0,0-.11,0,1.87,1.87,0,0,0-.77.2l-.25-.5a2.12,2.12,0,0,1,1.05-.25,1.26,1.26,0,0,1,.84.24.87.87,0,0,1,.29.73V132Zm-.22-1.27h-.28a1,1,0,0,0-.49.12.36.36,0,0,0-.16.33c0,.21.12.31.37.31a.56.56,0,0,0,.41-.15.51.51,0,0,0,.15-.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M225.83,131.14a.73.73,0,0,1-.29.64,1.47,1.47,0,0,1-.87.22h-.51a2.91,2.91,0,0,1-.39-.12v-.62a2.64,2.64,0,0,0,.47.17,1.74,1.74,0,0,0,.45.06c.27,0,.41-.08.41-.23a.19.19,0,0,0,0-.15l-.19-.12-.35-.16a2.05,2.05,0,0,1-.46-.25.75.75,0,0,1-.22-.25.89.89,0,0,1-.07-.36.68.68,0,0,1,.29-.57,1.4,1.4,0,0,1,.8-.19,2.46,2.46,0,0,1,1,.21l-.23.54-.38-.15a1.57,1.57,0,0,0-.37-.05q-.33,0-.33.18a.25.25,0,0,0,.11.17,2.86,2.86,0,0,0,.47.22,1.35,1.35,0,0,1,.46.24.51.51,0,0,1,.22.26A.65.65,0,0,1,225.83,131.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M227.65,132a1.41,1.41,0,0,1-1-.37,1.33,1.33,0,0,1-.37-1,1.47,1.47,0,0,1,.34-1.06,1.24,1.24,0,0,1,.95-.37,1.2,1.2,0,0,1,.9.33,1.23,1.23,0,0,1,.32.91v.36H227a.73.73,0,0,0,.19.49.66.66,0,0,0,.5.18,2.4,2.4,0,0,0,.46-.05,2.51,2.51,0,0,0,.46-.16v.57a1.5,1.5,0,0,1-.42.15A3.25,3.25,0,0,1,227.65,132Zm-.1-2.3a.46.46,0,0,0-.37.15.67.67,0,0,0-.16.42h1a.66.66,0,0,0-.15-.42A.48.48,0,0,0,227.55,129.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M231.81,132h-.74v-1.6a.75.75,0,0,0-.1-.44.35.35,0,0,0-.31-.15.46.46,0,0,0-.42.21,1.49,1.49,0,0,0-.13.69V132h-.74v-2.73h.57l.1.35h0a.67.67,0,0,1,.32-.3,1,1,0,0,1,.47-.1.87.87,0,0,1,.83.4h.07a.67.67,0,0,1,.32-.3,1.16,1.16,0,0,1,.49-.1,1,1,0,0,1,.7.23,1.06,1.06,0,0,1,.24.77V132h-.75v-1.6a.75.75,0,0,0-.1-.44.35.35,0,0,0-.31-.15.47.47,0,0,0-.41.2,1,1,0,0,0-.14.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M235.51,132a1.28,1.28,0,0,1-1.37-1.18v-.19a1.51,1.51,0,0,1,.35-1.06,1.39,1.39,0,0,1,1.85,0,1.27,1.27,0,0,1,.32.91v.36H234.9a.73.73,0,0,0,.19.49.64.64,0,0,0,.49.18,2.1,2.1,0,0,0,.92-.21v.57a1.56,1.56,0,0,1-.41.15A2.82,2.82,0,0,1,235.51,132Zm-.1-2.3a.46.46,0,0,0-.37.15.66.66,0,0,0-.15.42h1a.6.6,0,0,0-.14-.42.49.49,0,0,0-.34-.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M239.75,132H239v-1.6a.76.76,0,0,0-.11-.44.39.39,0,0,0-.33-.15.47.47,0,0,0-.45.21,1.26,1.26,0,0,0-.14.69V132h-.75v-2.73h.57l.1.35h0a.79.79,0,0,1,.35-.3,1.16,1.16,0,0,1,.49-.1,1,1,0,0,1,.73.25,1.07,1.07,0,0,1,.24.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M241.67,131.4a1.85,1.85,0,0,0,.47-.08v.55a1.8,1.8,0,0,1-.69.13.87.87,0,0,1-.65-.23,1,1,0,0,1-.2-.68v-1.31h-.36v-.32l.41-.25.22-.57h.47v.58h.77v.56h-.77v1.31a.3.3,0,0,0,.09.24A.34.34,0,0,0,241.67,131.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M221.69,139l-.21-1-.28-1.2h0l-.5,2.16h-.8l-.77-2.73h.74l.31,1.21a8.72,8.72,0,0,1,.16.89h0a2,2,0,0,1,.09-.59v-.2l.33-1.31h.82l.32,1.31v.79h0a1.13,1.13,0,0,1,.08-.48,1.15,1.15,0,0,0,.08-.41l.33-1.21h.73L222.5,139Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M226.21,137.58a1.46,1.46,0,0,1-.35,1,1.29,1.29,0,0,1-1,.38,1.39,1.39,0,0,1-.69-.18,1.11,1.11,0,0,1-.47-.49,1.78,1.78,0,0,1-.16-.75,1.46,1.46,0,0,1,.35-1,1.28,1.28,0,0,1,1-.37,1.32,1.32,0,0,1,.7.17,1.09,1.09,0,0,1,.46.49A1.61,1.61,0,0,1,226.21,137.58Zm-1.89,0a1.19,1.19,0,0,0,.14.61.46.46,0,0,0,.43.21.49.49,0,0,0,.43-.21,1.52,1.52,0,0,0,0-1.22.48.48,0,0,0-.44-.2.46.46,0,0,0-.43.2A1.18,1.18,0,0,0,224.32,137.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M228.35,136.17h.25l-.06.7h-.22a.79.79,0,0,0-.55.19.65.65,0,0,0-.2.51V139h-.75v-2.73h.57l.11.46h0a1,1,0,0,1,.35-.37A.78.78,0,0,1,228.35,136.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M229.81,137.46l.33-.41.76-.83h.84l-1.08,1.18,1.14,1.6H231l-.79-1.11-.32.26V139h-.75v-3.8h.75v2.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M234.1,138.14a.79.79,0,0,1-.29.64,1.47,1.47,0,0,1-.87.22h-.51a2.64,2.64,0,0,1-.4-.12v-.62a2.64,2.64,0,0,0,.47.17,1.76,1.76,0,0,0,.46.06c.27,0,.41-.08.41-.23a.2.2,0,0,0-.06-.15l-.18-.12-.36-.16a2.05,2.05,0,0,1-.46-.25.64.64,0,0,1-.21-.25.91.91,0,0,1-.1-.33.68.68,0,0,1,.28-.57,1.4,1.4,0,0,1,.8-.19,2.3,2.3,0,0,1,1,.21l-.22.54-.39-.15a1.49,1.49,0,0,0-.36-.05q-.33,0-.33.18a.2.2,0,0,0,.11.17,2.77,2.77,0,0,0,.46.22,1.89,1.89,0,0,1,.47.24.78.78,0,0,1,.22.26A.67.67,0,0,1,234.1,138.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M236,135.51c0-.24.13-.36.4-.36s.41.12.41.36a.38.38,0,0,1-.1.27.45.45,0,0,1-.31.1C236.08,135.88,236,135.76,236,135.51Zm.77,3.44H236v-2.73h.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M240,139h-.75v-1.6a.75.75,0,0,0-.1-.44.4.4,0,0,0-.34-.15.47.47,0,0,0-.45.21,1.26,1.26,0,0,0-.14.69V139h-.74v-2.73H238l.1.35h.05a.76.76,0,0,1,.34-.3,1.09,1.09,0,0,1,.5-.1,1,1,0,0,1,.72.25,1.08,1.08,0,0,1,.25.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M220.84,146a.91.91,0,0,1-.75-.35h0v1.5h-.74v-3.93h.6l.11.35h0a1,1,0,0,1,1.41-.12l.12.12a1.77,1.77,0,0,1,.27,1,2.46,2.46,0,0,1-.12.76,1,1,0,0,1-.37.49A1,1,0,0,1,220.84,146Zm-.22-2.24a.48.48,0,0,0-.4.17,1,1,0,0,0-.13.56v.08a1.06,1.06,0,0,0,.13.63.48.48,0,0,0,.41.19c.34,0,.51-.27.51-.82A1.26,1.26,0,0,0,221,144,.42.42,0,0,0,220.62,143.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M224,143.17h.25l-.05.7H224a.83.83,0,0,0-.56.19.65.65,0,0,0-.2.51V146h-.74v-2.73h.5l.11.46h0a1,1,0,0,1,.34-.37A.79.79,0,0,1,224,143.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M227.26,144.58a1.46,1.46,0,0,1-.35,1,1.29,1.29,0,0,1-1,.38,1.39,1.39,0,0,1-.69-.18,1.09,1.09,0,0,1-.46-.49,1.75,1.75,0,0,1-.17-.75,1.46,1.46,0,0,1,.35-1,1.28,1.28,0,0,1,1-.37,1.32,1.32,0,0,1,.7.17,1.09,1.09,0,0,1,.46.49A1.61,1.61,0,0,1,227.26,144.58Zm-1.89,0a1.19,1.19,0,0,0,.14.61.46.46,0,0,0,.43.21.49.49,0,0,0,.43-.21,1.52,1.52,0,0,0,0-1.22.48.48,0,0,0-.44-.2.44.44,0,0,0-.42.2A1.19,1.19,0,0,0,225.37,144.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M230.25,143.22v.38l-.43.11a.73.73,0,0,1,.12.41.82.82,0,0,1-.31.68,1.31,1.31,0,0,1-.85.25h-.24a.21.21,0,0,0-.11.19c0,.11.13.16.41.16h.46a1,1,0,0,1,.68.2.65.65,0,0,1,.24.56.82.82,0,0,1-.4.74,2.1,2.1,0,0,1-1.15.27,1.55,1.55,0,0,1-.87-.2.63.63,0,0,1-.3-.56.61.61,0,0,1,.15-.41,1,1,0,0,1,.46-.24.45.45,0,0,1-.2-.16.32.32,0,0,1-.09-.23.41.41,0,0,1,.09-.26,1.33,1.33,0,0,1,.26-.21.76.76,0,0,1-.34-.3.89.89,0,0,1-.13-.48.87.87,0,0,1,.3-.69,1.23,1.23,0,0,1,.83-.24h.47Zm-2.11,3.11a.28.28,0,0,0,.15.24.76.76,0,0,0,.42.09,1.34,1.34,0,0,0,.62-.11.33.33,0,0,0,.23-.3.21.21,0,0,0-.13-.21,1,1,0,0,0-.43,0h-.38a.55.55,0,0,0-.35.1A.29.29,0,0,0,228.14,146.33Zm.28-2.22a.55.55,0,0,0,.1.35.37.37,0,0,0,.31.13.34.34,0,0,0,.3-.13.55.55,0,0,0,.1-.35c0-.33-.13-.49-.4-.49S228.42,143.78,228.42,144.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M232.22,143.17h.26l-.06.7h-.22a.83.83,0,0,0-.56.19.69.69,0,0,0-.19.51V146h-.75v-2.73h.56l.11.46h0a1,1,0,0,1,.34-.37A.78.78,0,0,1,232.22,143.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M234.21,146a1.41,1.41,0,0,1-1-.37,1.34,1.34,0,0,1-.38-1,1.51,1.51,0,0,1,.35-1.06,1.39,1.39,0,0,1,1.85,0,1.27,1.27,0,0,1,.32.91v.36h-1.76a.73.73,0,0,0,.19.49.64.64,0,0,0,.49.18,1.85,1.85,0,0,0,.47,0,2.51,2.51,0,0,0,.46-.16v.57a1.5,1.5,0,0,1-.42.15A2.78,2.78,0,0,1,234.21,146Zm-.11-2.3a.46.46,0,0,0-.37.15.66.66,0,0,0-.15.42h1a.6.6,0,0,0-.14-.42A.49.49,0,0,0,234.1,143.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M237.83,145.14a.79.79,0,0,1-.29.64,1.5,1.5,0,0,1-.88.22h-.5a2.64,2.64,0,0,1-.4-.12v-.62a2.64,2.64,0,0,0,.47.17,1.76,1.76,0,0,0,.46.06c.27,0,.4-.08.4-.23a.21.21,0,0,0-.05-.15l-.18-.12-.36-.16a2.05,2.05,0,0,1-.46-.25.64.64,0,0,1-.21-.25.89.89,0,0,1-.07-.36.68.68,0,0,1,.28-.57,1.4,1.4,0,0,1,.8-.19,2.3,2.3,0,0,1,1,.21l-.22.54-.39-.15a1.49,1.49,0,0,0-.36-.05q-.33,0-.33.18a.21.21,0,0,0,.1.17,4,4,0,0,0,.47.22,1.89,1.89,0,0,1,.47.24.78.78,0,0,1,.22.26A.82.82,0,0,1,237.83,145.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M240.31,145.14a.73.73,0,0,1-.29.64,1.47,1.47,0,0,1-.87.22h-.51a2.91,2.91,0,0,1-.39-.12v-.62a2.64,2.64,0,0,0,.47.17,1.74,1.74,0,0,0,.45.06c.27,0,.41-.08.41-.23a.27.27,0,0,0-.05-.15l-.19-.12-.35-.16a2.05,2.05,0,0,1-.46-.25.75.75,0,0,1-.22-.25.89.89,0,0,1-.07-.36.68.68,0,0,1,.29-.57,1.4,1.4,0,0,1,.8-.19,2.46,2.46,0,0,1,1,.21l-.23.54-.38-.15a1.57,1.57,0,0,0-.37-.05q-.33,0-.33.18a.25.25,0,0,0,.11.17,2.86,2.86,0,0,0,.47.22,1.35,1.35,0,0,1,.46.24.51.51,0,0,1,.22.26A.82.82,0,0,1,240.31,145.14Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "office",
  className: "map_office"
}, /*#__PURE__*/React.createElement("rect", {
  className: "light-grey-large-map",
  x: 140.79,
  y: 68.44,
  width: 40.26,
  height: 23.94
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot_light",
  cx: 160,
  cy: 80,
  r: 3.5
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M152.09,77.23a.89.89,0,0,1-.35.77,1.55,1.55,0,0,1-1,.27,2.3,2.3,0,0,1-1-.21v-.7a4.44,4.44,0,0,0,.61.22,1.43,1.43,0,0,0,.46.07.64.64,0,0,0,.38-.1.31.31,0,0,0,.13-.28.33.33,0,0,0-.06-.19.61.61,0,0,0-.17-.15l-.46-.24a2.48,2.48,0,0,1-.49-.3.93.93,0,0,1-.26-.33,1,1,0,0,1,.22-1.18,1.34,1.34,0,0,1,.89-.27,2.33,2.33,0,0,1,.53.06,4.76,4.76,0,0,1,.53.19l-.25.59a3.75,3.75,0,0,0-.47-.17,2.29,2.29,0,0,0-.37,0,.48.48,0,0,0-.33.1.38.38,0,0,0-.07.43.54.54,0,0,0,.15.15l.48.25a1.81,1.81,0,0,1,.69.47A1,1,0,0,1,152.09,77.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M153.83,77.68a1.85,1.85,0,0,0,.47-.08v.55a1.6,1.6,0,0,1-.68.12.78.78,0,0,1-.65-.22,1,1,0,0,1-.21-.68V76.06h-.35v-.32l.41-.25.21-.57h.48v.58h.76v.56h-.76v1.31a.3.3,0,0,0,.09.24A.33.33,0,0,0,153.83,77.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M156.59,78.23l-.15-.38h0a1,1,0,0,1-.39.33,1.13,1.13,0,0,1-.51.09.8.8,0,0,1-.62-.22.87.87,0,0,1-.23-.64.7.7,0,0,1,.3-.64,1.75,1.75,0,0,1,.92-.23h.48v-.12a.38.38,0,0,0-.33-.42H156a1.87,1.87,0,0,0-.77.2l-.24-.5a2.18,2.18,0,0,1,1-.25,1.26,1.26,0,0,1,.84.24.88.88,0,0,1,.3.73v1.82ZM156.37,77h-.29a1,1,0,0,0-.49.12.39.39,0,0,0-.15.33c0,.21.12.31.36.31a.56.56,0,0,0,.41-.15.55.55,0,0,0,.16-.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M160.39,78.23h-.74v-1.6a.76.76,0,0,0-.11-.44.39.39,0,0,0-.33-.15.47.47,0,0,0-.45.21,1.26,1.26,0,0,0-.14.69v1.29h-.75V75.5h.57l.1.35h0a.69.69,0,0,1,.35-.3,1.16,1.16,0,0,1,.49-.1,1,1,0,0,1,.72.25,1,1,0,0,1,.25.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M162,78.27a.88.88,0,0,1-.75-.37,1.6,1.6,0,0,1-.28-1,1.77,1.77,0,0,1,.28-1.05.9.9,0,0,1,.77-.37.86.86,0,0,1,.79.4h0a2.53,2.53,0,0,1,0-.55v-.87h.74v3.8H163l-.14-.36h0A.86.86,0,0,1,162,78.27Zm.26-.59a.51.51,0,0,0,.42-.16,1,1,0,0,0,.15-.57v-.08a1.07,1.07,0,0,0-.14-.63.53.53,0,0,0-.83,0,1.22,1.22,0,0,0-.13.62,1,1,0,0,0,.14.6.45.45,0,0,0,.41.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M166.06,78.23l-.15-.38h0a1,1,0,0,1-.39.33,1.13,1.13,0,0,1-.51.09.8.8,0,0,1-.62-.22.87.87,0,0,1-.23-.64.71.71,0,0,1,.31-.64,1.71,1.71,0,0,1,.91-.23h.48v-.12a.38.38,0,0,0-.33-.42h-.1a1.87,1.87,0,0,0-.77.2l-.24-.5a2.18,2.18,0,0,1,1-.25,1.26,1.26,0,0,1,.84.24.88.88,0,0,1,.3.73v1.82ZM165.84,77h-.29a1,1,0,0,0-.49.12.39.39,0,0,0-.15.33c0,.21.12.31.36.31a.56.56,0,0,0,.41-.15.55.55,0,0,0,.16-.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M168.87,75.45a1,1,0,0,1,.25,0l-.06.7a.81.81,0,0,0-.22,0,.78.78,0,0,0-.55.18.68.68,0,0,0-.2.52v1.39h-.75V75.5h.57l.09.5h0a1,1,0,0,1,.35-.37A.82.82,0,0,1,168.87,75.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M170.48,78.27a.91.91,0,0,1-.76-.37,1.77,1.77,0,0,1-.27-1,1.7,1.7,0,0,1,.28-1.05.88.88,0,0,1,.77-.37.9.9,0,0,1,.78.4h0a2.57,2.57,0,0,1-.06-.55v-.87H172v3.8h-.57l-.15-.36h0A.85.85,0,0,1,170.48,78.27Zm.26-.59a.51.51,0,0,0,.42-.16,1,1,0,0,0,.14-.57v-.08a1.14,1.14,0,0,0-.13-.63.47.47,0,0,0-.44-.19.42.42,0,0,0-.39.21,1.2,1.2,0,0,0-.14.62,1.13,1.13,0,0,0,.14.6.46.46,0,0,0,.4.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M157.2,83.44a1.88,1.88,0,0,1-.44,1.36,1.92,1.92,0,0,1-2.52,0,2,2,0,0,1-.44-1.37,1.72,1.72,0,0,1,3-1.36A2,2,0,0,1,157.2,83.44Zm-2.6,0a1.49,1.49,0,0,0,.22.9.81.81,0,0,0,.68.3c.61,0,.91-.4.91-1.2s-.3-1.21-.9-1.21a.78.78,0,0,0-.68.3,1.53,1.53,0,0,0-.23.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M159.39,83.06h-.64v2.17H158V83.06h-.41V82.7l.41-.2v-.2a.92.92,0,0,1,.23-.69,1.09,1.09,0,0,1,.74-.21,2,2,0,0,1,.68.11l-.19.55a1.14,1.14,0,0,0-.41-.07.25.25,0,0,0-.23.1.34.34,0,0,0-.07.24v.17h.64Zm1.94,0h-.65v2.17h-.74V83.06h-.41V82.7l.41-.2v-.2a.92.92,0,0,1,.23-.69,1.06,1.06,0,0,1,.73-.21,2,2,0,0,1,.69.11l-.19.55A1.34,1.34,0,0,0,161,82a.23.23,0,0,0-.22.1.41.41,0,0,0-.08.24v.17h.65Zm.39-1.27c0-.24.13-.36.4-.36s.41.12.41.36a.38.38,0,0,1-.1.27.45.45,0,0,1-.31.1.36.36,0,0,1-.4-.32Zm.77,3.44h-.74V82.5h.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M164.38,85.27c-.85,0-1.27-.46-1.27-1.39a1.49,1.49,0,0,1,.35-1.07,1.29,1.29,0,0,1,1-.36,2.09,2.09,0,0,1,.85.18l-.22.58-.33-.12a.76.76,0,0,0-.3,0c-.39,0-.58.27-.58.82s.19.8.58.8a1.34,1.34,0,0,0,.4-.06,1,1,0,0,0,.36-.18v.64a1.17,1.17,0,0,1-.36.16A1.93,1.93,0,0,1,164.38,85.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M167.08,85.27a1.47,1.47,0,0,1-1-.36,1.37,1.37,0,0,1-.37-1,1.47,1.47,0,0,1,.34-1.06,1.24,1.24,0,0,1,.95-.37,1.19,1.19,0,0,1,.9.32,1.24,1.24,0,0,1,.32.92v.36h-1.76a.73.73,0,0,0,.19.49.66.66,0,0,0,.5.18,2.1,2.1,0,0,0,.92-.21v.57a1.5,1.5,0,0,1-.42.15A2.72,2.72,0,0,1,167.08,85.27ZM167,83a.46.46,0,0,0-.38.16.72.72,0,0,0-.15.42h1.05a.66.66,0,0,0-.15-.42A.44.44,0,0,0,167,83Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "kitchen",
  className: "map_kitchen"
}, /*#__PURE__*/React.createElement("rect", {
  className: "light-grey-large-map",
  x: 209.47,
  y: 68.44,
  width: 40.26,
  height: 23.94
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot_light",
  cx: 230,
  cy: 80,
  r: 3.5
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M221.45,75.23h-.86l-.94-1.5-.32.23v1.27h-.76V71.66h.76V73.3l.3-.42,1-1.22h.84l-1.25,1.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M221.8,71.8c0-.24.14-.37.41-.37s.41.13.41.37a.39.39,0,0,1-.11.27.4.4,0,0,1-.3.09.36.36,0,0,1-.41-.31Zm.78,3.43h-.74V72.5h.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M224.51,74.69a1.86,1.86,0,0,0,.47-.09v.56a1.6,1.6,0,0,1-.68.12.78.78,0,0,1-.65-.22,1,1,0,0,1-.21-.68V73.06h-.35v-.31l.41-.25.21-.58h.48v.58H225v.56h-.76v1.32a.28.28,0,0,0,.09.23A.37.37,0,0,0,224.51,74.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M226.64,75.28c-.85,0-1.27-.46-1.27-1.4a1.47,1.47,0,0,1,.34-1.06,1.28,1.28,0,0,1,1-.37,1.79,1.79,0,0,1,.85.19l-.22.57L227,73.1a.76.76,0,0,0-.3,0c-.39,0-.58.28-.58.83s.19.8.58.8a1.32,1.32,0,0,0,.39-.06,1.27,1.27,0,0,0,.37-.18v.64a1.17,1.17,0,0,1-.36.16A2.36,2.36,0,0,1,226.64,75.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M230.62,75.23h-.74V73.64c0-.4-.15-.59-.44-.59a.47.47,0,0,0-.45.21,1.26,1.26,0,0,0-.14.69v1.28h-.75v-3.8h.75v1.42h0a.86.86,0,0,1,.79-.4,1,1,0,0,1,.73.26,1,1,0,0,1,.25.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M232.62,75.28a1.47,1.47,0,0,1-1-.36,1.41,1.41,0,0,1-.37-1,1.51,1.51,0,0,1,.35-1.06,1.39,1.39,0,0,1,1.85,0,1.27,1.27,0,0,1,.32.91v.36H232a.71.71,0,0,0,.19.5.64.64,0,0,0,.49.18,1.85,1.85,0,0,0,.47,0,2.2,2.2,0,0,0,.45-.17v.58a2,2,0,0,1-.41.14A2.24,2.24,0,0,1,232.62,75.28Zm-.1-2.3a.46.46,0,0,0-.37.15.73.73,0,0,0-.16.43h1a.6.6,0,0,0-.14-.43.51.51,0,0,0-.33-.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M236.86,75.23h-.74V73.64a.76.76,0,0,0-.11-.44.39.39,0,0,0-.33-.15.47.47,0,0,0-.45.21,1.26,1.26,0,0,0-.14.69v1.28h-.75V72.5h.57l.1.35h0a.92.92,0,0,1,.35-.3,1.16,1.16,0,0,1,.49-.1,1,1,0,0,1,.73.26,1,1,0,0,1,.24.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M240.58,71.66l-1.33,3.57h-.68l1.33-3.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M217.72,79.24a.78.78,0,0,0-.66.32,1.51,1.51,0,0,0-.24.9c0,.79.3,1.19.9,1.19a2.84,2.84,0,0,0,.91-.19v.64a2.46,2.46,0,0,1-1,.18,1.49,1.49,0,0,1-1.19-.47,2.52,2.52,0,0,1-.21-2.36,1.44,1.44,0,0,1,.58-.64,1.65,1.65,0,0,1,.89-.23,2.46,2.46,0,0,1,1,.25l-.24.62-.4-.17A1.32,1.32,0,0,0,217.72,79.24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M221.81,80.86a1.53,1.53,0,0,1-.35,1,1.28,1.28,0,0,1-1,.37,1.5,1.5,0,0,1-.69-.17,1.09,1.09,0,0,1-.46-.49,1.68,1.68,0,0,1-.16-.76,1.52,1.52,0,0,1,.34-1,1.33,1.33,0,0,1,1-.37,1.5,1.5,0,0,1,.69.17,1.2,1.2,0,0,1,.46.49A1.69,1.69,0,0,1,221.81,80.86Zm-1.89,0a1.2,1.2,0,0,0,.14.62.56.56,0,0,0,.79.07h0a.23.23,0,0,0,.07-.07,1.12,1.12,0,0,0,.13-.62,1,1,0,0,0-.13-.6.54.54,0,0,0-.76-.1h0l-.09.09A1.13,1.13,0,0,0,219.92,80.86Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M224.87,82.23h-.74V80.64a.84.84,0,0,0-.1-.44.35.35,0,0,0-.31-.15.46.46,0,0,0-.42.21,1.35,1.35,0,0,0-.13.69v1.28h-.74V79.5H223l.1.35h0a.79.79,0,0,1,.31-.29,1.13,1.13,0,0,1,.48-.11.87.87,0,0,1,.83.4h.07a.74.74,0,0,1,.32-.29,1.13,1.13,0,0,1,.48-.11.94.94,0,0,1,.7.24,1,1,0,0,1,.24.76v1.78h-.74V80.64a.84.84,0,0,0-.1-.44.35.35,0,0,0-.31-.15.46.46,0,0,0-.41.19,1.11,1.11,0,0,0-.14.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M229.78,82.23H229V80.64a.84.84,0,0,0-.1-.44.35.35,0,0,0-.31-.15.46.46,0,0,0-.42.21A1.29,1.29,0,0,0,228,81v1.28h-.74V79.5h.57l.1.35h0a.79.79,0,0,1,.31-.29,1.13,1.13,0,0,1,.48-.11.87.87,0,0,1,.83.4h.07a.74.74,0,0,1,.32-.29,1.13,1.13,0,0,1,.48-.11.94.94,0,0,1,.7.24,1,1,0,0,1,.24.76v1.78h-.74V80.64a.84.84,0,0,0-.1-.44.36.36,0,0,0-.32-.15.45.45,0,0,0-.4.19,1.11,1.11,0,0,0-.14.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M234.18,82.23l-.1-.35h0a.76.76,0,0,1-.34.3,1.24,1.24,0,0,1-.5.1.91.91,0,0,1-.72-.26,1,1,0,0,1-.25-.74V79.5H233v1.6a.75.75,0,0,0,.1.44.38.38,0,0,0,.34.15.52.52,0,0,0,.45-.21,1.26,1.26,0,0,0,.14-.69V79.5h.74v2.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M238.05,82.23h-.74V80.64a.76.76,0,0,0-.11-.44.39.39,0,0,0-.33-.15.47.47,0,0,0-.45.21,1.26,1.26,0,0,0-.14.69v1.28h-.75V79.5h.57l.1.35h0a.92.92,0,0,1,.35-.3,1.16,1.16,0,0,1,.49-.1,1,1,0,0,1,.73.26,1,1,0,0,1,.24.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M240.55,82.23l-.14-.37h0a1.13,1.13,0,0,1-.39.33,1.14,1.14,0,0,1-.52.09.88.88,0,0,1-.62-.22.84.84,0,0,1-.22-.64.7.7,0,0,1,.3-.64,1.75,1.75,0,0,1,.92-.23h.47v-.12a.38.38,0,0,0-.3-.43h-.15a1.87,1.87,0,0,0-.77.2l-.25-.51a2.28,2.28,0,0,1,1.05-.24,1.31,1.31,0,0,1,.84.24.89.89,0,0,1,.29.72v1.82ZM240.33,81H240a.8.8,0,0,0-.48.12.34.34,0,0,0-.16.32c0,.21.12.32.36.32a.59.59,0,0,0,.42-.15.54.54,0,0,0,.15-.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M242.58,82.23h-.74v-3.8h.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M226.15,89.23l-.26-.85h-1.3l-.26.85h-.81l1.26-3.58h.92l1.3,3.58Zm-.44-1.48c-.24-.77-.37-1.21-.4-1.31l-.07-.24c-.05.21-.2.73-.46,1.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M228.88,86.45h.25v.7h-.22a.82.82,0,0,0-.56.18.65.65,0,0,0-.2.51v1.39h-.74V86.5H228V87h0a1.09,1.09,0,0,1,.34-.37A.86.86,0,0,1,228.88,86.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M230.86,89.28a1.27,1.27,0,0,1-1.4-1.13h0a1.13,1.13,0,0,1,0-.26,1.57,1.57,0,0,1,.34-1.06,1.22,1.22,0,0,1,.95-.38,1.2,1.2,0,0,1,.9.33,1.23,1.23,0,0,1,.33.91v.36h-1.76a.72.72,0,0,0,.18.5.68.68,0,0,0,.5.18,1.77,1.77,0,0,0,.46,0,2.54,2.54,0,0,0,.46-.17v.58a2,2,0,0,1-.41.14A2.53,2.53,0,0,1,230.86,89.28Zm-.1-2.3a.46.46,0,0,0-.37.15.73.73,0,0,0-.16.43h1.05a.61.61,0,0,0-.15-.43.46.46,0,0,0-.37-.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M234.32,89.23l-.15-.37h0a1,1,0,0,1-.39.33,1.13,1.13,0,0,1-.51.09.8.8,0,0,1-.62-.22.87.87,0,0,1-.23-.64.7.7,0,0,1,.3-.64,1.75,1.75,0,0,1,.92-.23h.48v-.12a.37.37,0,0,0-.34-.41h-.09a1.87,1.87,0,0,0-.77.2l-.24-.51a2.17,2.17,0,0,1,1-.24,1.26,1.26,0,0,1,.84.24.87.87,0,0,1,.3.72v1.82ZM234.1,88h-.29a.85.85,0,0,0-.49.12.36.36,0,0,0-.15.32c0,.21.12.32.36.32a.56.56,0,0,0,.41-.15.55.55,0,0,0,.16-.4Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "ambassadors_office",
  className: "map_ambassadors_office",
  "data-name": "ambassadors office"
}, /*#__PURE__*/React.createElement("rect", {
  className: "light-grey-large-map",
  x: 140.79,
  y: 40.15,
  width: 40.26,
  height: 23.94
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot_light",
  cx: 160,
  cy: 53,
  r: 3.5
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M146.28,49.93l-.26-.85h-1.3l-.26.85h-.82l1.26-3.58h.93l1.26,3.58Zm-.44-1.48c-.24-.77-.37-1.21-.4-1.31s-.06-.18-.07-.24c-.05.21-.21.73-.46,1.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M149.93,49.93h-.75V48.34a.85.85,0,0,0-.09-.44.36.36,0,0,0-.32-.15.46.46,0,0,0-.41.21,1.35,1.35,0,0,0-.13.69v1.28h-.75V47.2h.57l.1.35h0a.67.67,0,0,1,.31-.29,1.13,1.13,0,0,1,.48-.11.87.87,0,0,1,.83.4h.06a.92.92,0,0,1,.33-.29,1.13,1.13,0,0,1,.48-.11.94.94,0,0,1,.7.24,1,1,0,0,1,.24.76v1.78h-.75V48.34a.75.75,0,0,0-.1-.44.35.35,0,0,0-.31-.15.48.48,0,0,0-.41.19,1.12,1.12,0,0,0-.13.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M153.91,47.15a.88.88,0,0,1,.76.38,2,2,0,0,1,0,2,.9.9,0,0,1-.77.37.91.91,0,0,1-.75-.35h0l-.13.3h-.57V46.14h.75v1.4h0A.87.87,0,0,1,153.91,47.15Zm-.24.6a.48.48,0,0,0-.4.17,1,1,0,0,0-.13.56v.08a1.14,1.14,0,0,0,.13.63.46.46,0,0,0,.41.19.44.44,0,0,0,.37-.21,1.22,1.22,0,0,0,.13-.62,1,1,0,0,0-.13-.6A.44.44,0,0,0,153.67,47.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M157.29,49.93l-.14-.37h0a1.13,1.13,0,0,1-.39.33,1.14,1.14,0,0,1-.52.09.88.88,0,0,1-.62-.22.84.84,0,0,1-.22-.64.7.7,0,0,1,.3-.64,1.75,1.75,0,0,1,.92-.23h.47v-.12a.37.37,0,0,0-.31-.42h-.11a1.87,1.87,0,0,0-.77.2l-.25-.5a2.18,2.18,0,0,1,1-.25,1.31,1.31,0,0,1,.84.24.92.92,0,0,1,.29.73v1.81Zm-.22-1.26h-.29a.9.9,0,0,0-.48.12.34.34,0,0,0-.16.32c0,.21.12.32.36.32a.59.59,0,0,0,.42-.15.54.54,0,0,0,.15-.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M160.48,49.12a.73.73,0,0,1-.29.64,1.4,1.4,0,0,1-.87.22,2.17,2.17,0,0,1-.51,0,1.27,1.27,0,0,1-.39-.12v-.61a2.6,2.6,0,0,0,.47.16,1.76,1.76,0,0,0,.45.07c.27,0,.41-.08.41-.24a.2.2,0,0,0-.06-.14.57.57,0,0,0-.18-.12l-.35-.17a1.89,1.89,0,0,1-.47-.24.75.75,0,0,1-.21-.26.71.71,0,0,1-.07-.35.68.68,0,0,1,.28-.57,1.49,1.49,0,0,1,.8-.2,2.28,2.28,0,0,1,1,.22l-.22.54-.38-.15a1.15,1.15,0,0,0-.37,0c-.22,0-.33,0-.33.17a.27.27,0,0,0,.11.18,1.92,1.92,0,0,0,.46.21,1.92,1.92,0,0,1,.47.25.75.75,0,0,1,.22.25A1.15,1.15,0,0,1,160.48,49.12Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M163,49.12a.73.73,0,0,1-.29.64,1.43,1.43,0,0,1-.88.22,2.09,2.09,0,0,1-.5,0,1.42,1.42,0,0,1-.4-.12v-.61a2.6,2.6,0,0,0,.47.16,1.77,1.77,0,0,0,.46.07c.27,0,.4-.08.4-.24a.17.17,0,0,0,0-.14.76.76,0,0,0-.19-.12c-.08,0-.2-.1-.35-.17a2,2,0,0,1-.46-.24.49.49,0,0,1-.21-.26A.65.65,0,0,1,161,48a.64.64,0,0,1,.28-.57,1.33,1.33,0,0,1,.8-.2,2.28,2.28,0,0,1,1,.22l-.23.54-.38-.15a1.09,1.09,0,0,0-.36,0c-.22,0-.33,0-.33.17a.22.22,0,0,0,.1.18,2.18,2.18,0,0,0,.47.21,2.12,2.12,0,0,1,.47.25.75.75,0,0,1,.22.25A1.7,1.7,0,0,1,163,49.12Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M165.28,49.93l-.14-.37h0a1.13,1.13,0,0,1-.39.33,1.14,1.14,0,0,1-.52.09.88.88,0,0,1-.62-.22.84.84,0,0,1-.22-.64.7.7,0,0,1,.3-.64,1.75,1.75,0,0,1,.92-.23h.47v-.12a.37.37,0,0,0-.31-.42h-.11a1.87,1.87,0,0,0-.77.2l-.25-.5a2.18,2.18,0,0,1,1-.25,1.31,1.31,0,0,1,.84.24.92.92,0,0,1,.29.73v1.81Zm-.22-1.26h-.29a.9.9,0,0,0-.48.12.39.39,0,0,0-.16.32c0,.21.12.32.36.32a.59.59,0,0,0,.42-.15.54.54,0,0,0,.15-.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M167.43,50a.88.88,0,0,1-.75-.37,1.62,1.62,0,0,1-.28-1,1.78,1.78,0,0,1,.28-1,1,1,0,0,1,.77-.38.9.9,0,0,1,.79.4h0a4.86,4.86,0,0,1,0-.54v-.87H169V50h-.57l-.14-.35h0A.85.85,0,0,1,167.43,50Zm.26-.59a.52.52,0,0,0,.42-.17.93.93,0,0,0,.15-.56V48.6a1.07,1.07,0,0,0-.14-.63.47.47,0,0,0-.44-.19.45.45,0,0,0-.38.21,1.38,1.38,0,0,0,0,1.22.46.46,0,0,0,.39.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M172.21,48.56a1.46,1.46,0,0,1-.35,1,1.52,1.52,0,0,1-1.69.2,1.09,1.09,0,0,1-.46-.49,1.68,1.68,0,0,1-.16-.76,1.46,1.46,0,0,1,.35-1,1.28,1.28,0,0,1,1-.37,1.5,1.5,0,0,1,.69.17,1.17,1.17,0,0,1,.46.5A1.61,1.61,0,0,1,172.21,48.56Zm-1.88,0a1.22,1.22,0,0,0,.13.62.54.54,0,0,0,.76.1h0l.09-.09a1.12,1.12,0,0,0,.13-.62,1,1,0,0,0-.13-.6.54.54,0,0,0-.76-.1h0l-.09.09A1,1,0,0,0,170.33,48.56Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M174.35,47.15h.25v.69h-.22a.82.82,0,0,0-.56.18.68.68,0,0,0-.2.52v1.38h-.74V47.2h.56l.11.46h0a1.09,1.09,0,0,1,.34-.37A.86.86,0,0,1,174.35,47.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M175.7,46.36v.06a7.15,7.15,0,0,1-.43,1.17h-.53q.16-.72.24-1.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M178.09,49.12a.73.73,0,0,1-.29.64,1.43,1.43,0,0,1-.88.22,2.09,2.09,0,0,1-.5,0,1.42,1.42,0,0,1-.4-.12v-.61a2.6,2.6,0,0,0,.47.16,1.77,1.77,0,0,0,.46.07c.27,0,.4-.08.4-.24a.33.33,0,0,0,0-.14.76.76,0,0,0-.19-.12c-.08,0-.2-.1-.35-.17a2,2,0,0,1-.46-.24.78.78,0,0,1-.22-.26,1,1,0,0,1-.06-.35.64.64,0,0,1,.28-.57,1.33,1.33,0,0,1,.8-.2,2.28,2.28,0,0,1,1,.22l-.23.54-.38-.15a1.09,1.09,0,0,0-.36,0c-.22,0-.33,0-.33.17a.22.22,0,0,0,.1.18,2.18,2.18,0,0,0,.47.21,2.12,2.12,0,0,1,.47.25.75.75,0,0,1,.22.25A1.14,1.14,0,0,1,178.09,49.12Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M157.2,55.14a1.89,1.89,0,0,1-.44,1.37,1.92,1.92,0,0,1-2.52,0,2,2,0,0,1-.44-1.37,1.72,1.72,0,0,1,3-1.36A2,2,0,0,1,157.2,55.14Zm-2.6,0a1.52,1.52,0,0,0,.22.91.81.81,0,0,0,.68.3c.61,0,.91-.4.91-1.21s-.3-1.2-.9-1.2a.78.78,0,0,0-.68.3,1.5,1.5,0,0,0-.23.9Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M159.39,54.76h-.64v2.17H158V54.76h-.41v-.35l.41-.21V54a.89.89,0,0,1,.23-.68,1.09,1.09,0,0,1,.74-.21,2,2,0,0,1,.68.11l-.19.55a1.14,1.14,0,0,0-.41-.07.25.25,0,0,0-.23.09.4.4,0,0,0-.07.24v.17h.64Zm1.94,0h-.65v2.17h-.74V54.76h-.41v-.35l.41-.21V54a.89.89,0,0,1,.23-.68,1.06,1.06,0,0,1,.73-.21,2,2,0,0,1,.69.11l-.19.55a1.2,1.2,0,0,0-.42-.07.24.24,0,0,0-.22.09.41.41,0,0,0-.08.24v.17h.65Zm.39-1.26c0-.24.13-.36.4-.36s.41.12.41.36a.35.35,0,0,1-.41.37C161.85,53.87,161.72,53.74,161.72,53.5Zm.77,3.43h-.74V54.2h.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M164.38,57c-.85,0-1.27-.46-1.27-1.4a1.45,1.45,0,0,1,.35-1.06,1.33,1.33,0,0,1,1-.37,2,2,0,0,1,.85.19l-.22.58-.33-.12a.76.76,0,0,0-.3,0c-.39,0-.58.28-.58.83s.19.8.58.8a1.34,1.34,0,0,0,.4-.06,1.22,1.22,0,0,0,.36-.18v.64a1.17,1.17,0,0,1-.36.16A1.93,1.93,0,0,1,164.38,57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M167.08,57a1.47,1.47,0,0,1-1-.36,1.37,1.37,0,0,1-.37-1,1.47,1.47,0,0,1,.34-1.06,1.22,1.22,0,0,1,.95-.38,1.2,1.2,0,0,1,.9.33,1.23,1.23,0,0,1,.32.91v.37h-1.76a.73.73,0,0,0,.19.49.66.66,0,0,0,.5.18,1.77,1.77,0,0,0,.46,0,2.54,2.54,0,0,0,.46-.17v.58a1.5,1.5,0,0,1-.42.15A2.73,2.73,0,0,1,167.08,57Zm-.1-2.3a.5.5,0,0,0-.38.15.66.66,0,0,0-.15.43h1.05a.66.66,0,0,0-.15-.43.47.47,0,0,0-.35-.17Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "server_room",
  className: "map_server_room",
  "data-name": "server room"
}, /*#__PURE__*/React.createElement("rect", {
  className: "light-grey-large-map",
  x: 209.47,
  y: 40.15,
  width: 40.26,
  height: 23.94
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot_light",
  cx: 230,
  cy: 53,
  r: 3.5
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M216.05,53.72a.93.93,0,0,1-.35.76,1.48,1.48,0,0,1-1,.28,2.15,2.15,0,0,1-1-.22v-.7a4.49,4.49,0,0,0,.61.23,1.76,1.76,0,0,0,.46.06.63.63,0,0,0,.38-.09.31.31,0,0,0,.13-.28.41.41,0,0,0-.05-.19.55.55,0,0,0-.18-.16,4,4,0,0,0-.46-.24,1.9,1.9,0,0,1-.49-.3.93.93,0,0,1-.26-.33.86.86,0,0,1-.1-.44,1,1,0,0,1,.32-.74,1.36,1.36,0,0,1,.89-.27,1.88,1.88,0,0,1,.53.07,2.55,2.55,0,0,1,.53.18l-.24.59a3,3,0,0,0-.48-.16,1.12,1.12,0,0,0-.36-.05.44.44,0,0,0-.33.1.32.32,0,0,0-.12.26.34.34,0,0,0,.05.17.54.54,0,0,0,.15.15,2.73,2.73,0,0,0,.48.25,1.91,1.91,0,0,1,.68.48A1.06,1.06,0,0,1,216.05,53.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M217.87,54.76a1.37,1.37,0,0,1-1-.37,1.33,1.33,0,0,1-.37-1,1.57,1.57,0,0,1,.34-1.06,1.24,1.24,0,0,1,.95-.37,1.2,1.2,0,0,1,.9.33,1.23,1.23,0,0,1,.32.91v.36h-1.76a.78.78,0,0,0,.19.5.69.69,0,0,0,.49.17,1.85,1.85,0,0,0,.47,0,2.51,2.51,0,0,0,.46-.16v.58a1.88,1.88,0,0,1-.42.14A2.73,2.73,0,0,1,217.87,54.76Zm-.1-2.3a.5.5,0,0,0-.38.15.66.66,0,0,0-.15.42h1a.66.66,0,0,0-.15-.42A.48.48,0,0,0,217.77,52.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M221.11,51.93h.25l-.05.7a.81.81,0,0,0-.22,0,.83.83,0,0,0-.56.19.65.65,0,0,0-.2.51v1.39h-.74V52h.56l.11.46h0a1,1,0,0,1,.34-.37A.93.93,0,0,1,221.11,51.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M222.51,54.71l-1-2.73h.78l.53,1.56a3.35,3.35,0,0,1,.11.55h0a2.07,2.07,0,0,1,.11-.55l.52-1.56h.78l-1,2.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M225.94,54.76a1.37,1.37,0,0,1-1-.37,1.33,1.33,0,0,1-.37-1,1.57,1.57,0,0,1,.34-1.06,1.46,1.46,0,0,1,1.9,0,1.23,1.23,0,0,1,.32.91v.36h-1.76a.78.78,0,0,0,.19.5.69.69,0,0,0,.49.17,1.85,1.85,0,0,0,.47,0A2.27,2.27,0,0,0,227,54v.58a1.88,1.88,0,0,1-.42.14A2.76,2.76,0,0,1,225.94,54.76Zm-.11-2.3a.48.48,0,0,0-.37.15.66.66,0,0,0-.15.42h1a.6.6,0,0,0-.14-.42A.49.49,0,0,0,225.83,52.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M229.18,51.93h.25l-.05.7a.81.81,0,0,0-.22,0,.83.83,0,0,0-.56.19.65.65,0,0,0-.2.51v1.39h-.74V52h.56l.11.46h0a1,1,0,0,1,.34-.37A.93.93,0,0,1,229.18,51.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M232,53.34v1.37h-.75V51.14h1a1.75,1.75,0,0,1,1.07.27.89.89,0,0,1,.35.8,1,1,0,0,1-.17.56,1.21,1.21,0,0,1-.49.38c.53.81.86,1.33,1,1.56h-.84l-.85-1.37Zm0-.62h.25a1.08,1.08,0,0,0,.53-.11.43.43,0,0,0,.17-.38.4.4,0,0,0-.18-.36,1,1,0,0,0-.54-.11H232Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M237,53.34a1.46,1.46,0,0,1-.35,1,1.29,1.29,0,0,1-1,.38,1.57,1.57,0,0,1-.7-.17,1.17,1.17,0,0,1-.46-.5,1.74,1.74,0,0,1-.16-.75,1.46,1.46,0,0,1,.35-1,1.28,1.28,0,0,1,1-.37,1.57,1.57,0,0,1,.7.17,1.09,1.09,0,0,1,.46.49A1.74,1.74,0,0,1,237,53.34Zm-1.89,0a1.18,1.18,0,0,0,.13.61.51.51,0,0,0,.44.21.49.49,0,0,0,.43-.21,1.52,1.52,0,0,0,0-1.22.5.5,0,0,0-.44-.2.48.48,0,0,0-.43.2,1.28,1.28,0,0,0-.12.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M240.1,53.34a1.46,1.46,0,0,1-.35,1,1.25,1.25,0,0,1-1,.38,1.5,1.5,0,0,1-.69-.17,1.17,1.17,0,0,1-.46-.5,1.61,1.61,0,0,1-.16-.75,1.41,1.41,0,0,1,.35-1,1.28,1.28,0,0,1,1-.37,1.5,1.5,0,0,1,.69.17,1.09,1.09,0,0,1,.46.49A1.61,1.61,0,0,1,240.1,53.34Zm-1.88,0a1.18,1.18,0,0,0,.13.61.54.54,0,0,0,.76.1h0l.09-.09a1.09,1.09,0,0,0,.13-.61,1.18,1.18,0,0,0-.13-.61.56.56,0,0,0-.79-.07h0l-.07.07A1.09,1.09,0,0,0,238.22,53.34Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M243.16,54.71h-.74V53.12a.79.79,0,0,0-.1-.45.35.35,0,0,0-.31-.15.46.46,0,0,0-.42.21,1.41,1.41,0,0,0-.13.7v1.28h-.74V52h.57l.1.35h0a.84.84,0,0,1,.32-.3,1,1,0,0,1,.47-.1.87.87,0,0,1,.83.4h.07a.67.67,0,0,1,.32-.3,1.16,1.16,0,0,1,.49-.1,1,1,0,0,1,.7.24,1,1,0,0,1,.24.76v1.78h-.75V53.12a.87.87,0,0,0-.1-.45.35.35,0,0,0-.31-.15.47.47,0,0,0-.41.2,1.11,1.11,0,0,0-.14.62Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "roof",
  className: "map_roof"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "light-grey-large-map",
  points: "139.99 33.08 250.96 33.08 233.73 14.89 157.5 14.89 139.99 33.08"
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot_light",
  cx: 196,
  cy: 19.3,
  r: 3.5
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M190.75,25.53V26.9H190V23.33h1a1.72,1.72,0,0,1,1.08.27,1,1,0,0,1,.35.8.94.94,0,0,1-.18.56,1,1,0,0,1-.49.39l1.05,1.55H192l-.85-1.37Zm0-.61H191a1,1,0,0,0,.53-.12.43.43,0,0,0,.17-.38.38.38,0,0,0-.17-.36A1.19,1.19,0,0,0,191,24h-.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M195.71,25.53a1.46,1.46,0,0,1-.35,1,1.28,1.28,0,0,1-1,.37,1.5,1.5,0,0,1-.69-.17,1.2,1.2,0,0,1-.46-.49,1.68,1.68,0,0,1-.16-.76,1.46,1.46,0,0,1,.35-1,1.28,1.28,0,0,1,1-.37,1.5,1.5,0,0,1,.69.17,1.09,1.09,0,0,1,.46.49A1.68,1.68,0,0,1,195.71,25.53Zm-1.88,0a1.22,1.22,0,0,0,.13.62.48.48,0,0,0,.43.2.46.46,0,0,0,.43-.2,1.12,1.12,0,0,0,.13-.62,1,1,0,0,0-.13-.6.54.54,0,0,0-.77-.09.76.76,0,0,0-.09.09A1.15,1.15,0,0,0,193.83,25.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M198.81,25.53a1.53,1.53,0,0,1-.35,1,1.28,1.28,0,0,1-1,.37,1.5,1.5,0,0,1-.69-.17,1.3,1.3,0,0,1-.47-.49,1.82,1.82,0,0,1-.16-.76,1.46,1.46,0,0,1,.35-1,1.33,1.33,0,0,1,1-.37,1.42,1.42,0,0,1,.7.17,1.2,1.2,0,0,1,.46.49A1.68,1.68,0,0,1,198.81,25.53Zm-1.89,0a1.2,1.2,0,0,0,.14.62.46.46,0,0,0,.43.2.48.48,0,0,0,.43-.2,1.52,1.52,0,0,0,0-1.22.56.56,0,0,0-.79-.08.3.3,0,0,0-.08.08A1.15,1.15,0,0,0,196.92,25.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M200.93,24.73h-.64V26.9h-.74V24.73h-.41v-.36l.41-.2V24a.93.93,0,0,1,.22-.68,1.09,1.09,0,0,1,.74-.21,2,2,0,0,1,.69.11l-.19.55a1.2,1.2,0,0,0-.42-.07.25.25,0,0,0-.23.09.4.4,0,0,0-.07.24v.17h.64Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "lift",
  className: "map_lift"
}, /*#__PURE__*/React.createElement("rect", {
  className: "light-grey-large-map",
  x: 185.4,
  y: 40.15,
  width: 19.71,
  height: 108.81
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot_light",
  cx: 195,
  cy: 76,
  r: 3.5
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M191.48,95.36V91.79h.75v2.95h1.45v.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M194.21,91.93c0-.24.14-.36.41-.36s.4.12.4.36a.34.34,0,0,1-.1.27.45.45,0,0,1-.3.1C194.35,92.3,194.21,92.17,194.21,91.93Zm.78,3.43h-.75V92.63H195Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M197.28,93.19h-.65v2.17h-.74V93.19h-.41v-.36l.41-.2v-.2a.89.89,0,0,1,.23-.68,1.06,1.06,0,0,1,.73-.21,2,2,0,0,1,.69.11l-.19.55a1.2,1.2,0,0,0-.42-.07.28.28,0,0,0-.23.09.51.51,0,0,0-.07.24v.17h.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M198.86,94.82a1.79,1.79,0,0,0,.46-.09v.56a1.6,1.6,0,0,1-.68.12.86.86,0,0,1-.65-.22,1,1,0,0,1-.2-.68V93.19h-.36v-.31l.41-.25.21-.58h.48v.58h.77v.56h-.77v1.32a.25.25,0,0,0,.09.23A.41.41,0,0,0,198.86,94.82Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "exterior_back",
  className: "map_exterior_back",
  "data-name": "exterior back"
}, /*#__PURE__*/React.createElement("rect", {
  className: "light-grey-large-map",
  x: 254.08,
  y: 96.73,
  width: 40.26,
  height: 23.94
}), /*#__PURE__*/React.createElement("circle", {
  className: "green_dot_light",
  cx: 275.06,
  cy: 108,
  r: 3.5
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M259.29,103.53h-2.05V100h2.05v.62H258v.78h1.21v.6H258v.92h1.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M260.54,102.13l-.88-1.33h.84l.53.86.54-.86h.84l-.88,1.33.93,1.4h-.85l-.58-.94-.57.94h-.85Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M264,103a1.85,1.85,0,0,0,.47-.08v.55a1.6,1.6,0,0,1-.68.12.89.89,0,0,1-.66-.22,1,1,0,0,1-.2-.68v-1.32h-.36V101l.41-.25.22-.58h.48v.59h.76v.55h-.76v1.32a.35.35,0,0,0,.08.24A.38.38,0,0,0,264,103Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M266.28,103.57a1.36,1.36,0,0,1-1-.36,1.38,1.38,0,0,1-.38-1,1.51,1.51,0,0,1,.35-1.06,1.38,1.38,0,0,1,1.85-.05,1.27,1.27,0,0,1,.32.91v.37h-1.76a.73.73,0,0,0,.19.49.64.64,0,0,0,.49.18,1.85,1.85,0,0,0,.47,0,2.54,2.54,0,0,0,.46-.17v.58a1.5,1.5,0,0,1-.42.15A2.73,2.73,0,0,1,266.28,103.57Zm-.11-2.3a.46.46,0,0,0-.37.15.66.66,0,0,0-.15.43h1a.6.6,0,0,0-.14-.43A.49.49,0,0,0,266.17,101.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M269.52,100.74h.25l-.06.69h-.22a.78.78,0,0,0-.55.18.68.68,0,0,0-.2.52v1.39H268V100.8h.57l.11.45h0a1,1,0,0,1,.34-.37A.81.81,0,0,1,269.52,100.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M270.23,100.09c0-.24.14-.36.41-.36s.4.12.4.36a.34.34,0,0,1-.1.27.41.41,0,0,1-.3.1C270.37,100.46,270.23,100.33,270.23,100.09Zm.78,3.44h-.74V100.8H271Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M274.27,102.16a1.46,1.46,0,0,1-.35,1,1.52,1.52,0,0,1-1.69.2,1.09,1.09,0,0,1-.46-.49,1.61,1.61,0,0,1-.16-.75,1.42,1.42,0,0,1,.34-1,1.32,1.32,0,0,1,1-.38,1.39,1.39,0,0,1,.69.18,1.09,1.09,0,0,1,.46.49A1.5,1.5,0,0,1,274.27,102.16Zm-1.89,0a1.19,1.19,0,0,0,.14.61.54.54,0,0,0,.76.1h0l.09-.09a1.18,1.18,0,0,0,.13-.61,1.09,1.09,0,0,0-.13-.61.49.49,0,0,0-.43-.21.46.46,0,0,0-.43.21A1.19,1.19,0,0,0,272.38,102.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M276.41,100.74h.25l-.05.69h-.22a.82.82,0,0,0-.56.18.68.68,0,0,0-.2.52v1.39h-.74V100.8h.56l.11.45h0a1.09,1.09,0,0,1,.34-.37A.84.84,0,0,1,276.41,100.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M280,100.74a.88.88,0,0,1,.76.38,1.78,1.78,0,0,1,.28,1,1.68,1.68,0,0,1-.29,1,1,1,0,0,1-1.41.11h0a.57.57,0,0,1-.11-.11h-.05l-.12.31h-.57v-3.8h.74v1.42h0A.88.88,0,0,1,280,100.74Zm-.23.6a.49.49,0,0,0-.41.17,1,1,0,0,0-.13.56v.08a1.14,1.14,0,0,0,.13.63.49.49,0,0,0,.42.19.41.41,0,0,0,.36-.21,1.38,1.38,0,0,0,0-1.22.46.46,0,0,0-.4-.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M283.35,103.53l-.14-.38h0a1.13,1.13,0,0,1-.39.33,1.14,1.14,0,0,1-.52.09.87.87,0,0,1-.61-.22.8.8,0,0,1-.23-.64.7.7,0,0,1,.3-.64,1.75,1.75,0,0,1,.92-.23h.47v-.12a.37.37,0,0,0-.31-.42h-.11a1.87,1.87,0,0,0-.77.2l-.25-.5a2.12,2.12,0,0,1,1.05-.25,1.26,1.26,0,0,1,.84.24.87.87,0,0,1,.29.73v1.82Zm-.22-1.27h-.28a1,1,0,0,0-.49.12.39.39,0,0,0-.16.32c0,.21.12.32.37.32a.56.56,0,0,0,.41-.15.51.51,0,0,0,.15-.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M285.75,103.57c-.85,0-1.28-.46-1.28-1.39a1.49,1.49,0,0,1,.35-1.07,1.33,1.33,0,0,1,1-.37,2,2,0,0,1,.85.19l-.22.58-.32-.12a.81.81,0,0,0-.31,0c-.38,0-.58.28-.58.83s.2.8.58.8a1.34,1.34,0,0,0,.4-.06,1.27,1.27,0,0,0,.37-.18v.64a1,1,0,0,1-.37.16A1.85,1.85,0,0,1,285.75,103.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M287.93,102l.32-.41.77-.83h.84L288.77,102l1.15,1.55h-.86l-.78-1.11-.32.26v.85h-.75v-3.8H288v2.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M290.21,101.16a.4.4,0,0,1,.11-.31.42.42,0,0,1,.32-.11.38.38,0,0,1,.42.34h0v.08a.51.51,0,0,1-.11.31.45.45,0,0,1-.31.1.46.46,0,0,1-.32-.1A.4.4,0,0,1,290.21,101.16Zm0,2a.4.4,0,0,1,.11-.31.42.42,0,0,1,.32-.11.38.38,0,0,1,.42.34v.08a.46.46,0,0,1-.11.3.51.51,0,0,1-.31.11.42.42,0,0,1-.32-.11.43.43,0,0,1-.11-.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M260.05,108.07a1.09,1.09,0,0,1-.36.88,1.51,1.51,0,0,1-1,.31h-.33v1.27h-.75V107h1.14a1.48,1.48,0,0,1,1,.28A1,1,0,0,1,260.05,108.07Zm-1.71.57h.25a.87.87,0,0,0,.52-.14.49.49,0,0,0,.18-.4.49.49,0,0,0-.15-.4.71.71,0,0,0-.45-.12h-.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M261.41,110.53h-.74v-3.8h.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M263.93,110.53l-.15-.38h0a1.1,1.1,0,0,1-.38.33,1.33,1.33,0,0,1-.52.09.8.8,0,0,1-.62-.22.87.87,0,0,1-.23-.64.71.71,0,0,1,.31-.64,1.71,1.71,0,0,1,.91-.23h.48v-.12a.38.38,0,0,0-.33-.42h-.1a1.87,1.87,0,0,0-.77.2l-.24-.5a2.18,2.18,0,0,1,1-.25,1.26,1.26,0,0,1,.84.24.88.88,0,0,1,.3.73v1.82Zm-.22-1.27h-.29a1,1,0,0,0-.49.12.36.36,0,0,0-.15.32c0,.21.12.32.36.32a.56.56,0,0,0,.41-.15.55.55,0,0,0,.16-.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M264.82,107.8h.82l.51,1.53a1.86,1.86,0,0,1,.09.47h0a2.46,2.46,0,0,1,.1-.47l.51-1.53h.8l-1.16,3.07a1.32,1.32,0,0,1-.45.64,1.07,1.07,0,0,1-.69.22H265v-.59a1.5,1.5,0,0,0,.3,0,.47.47,0,0,0,.34-.13.72.72,0,0,0,.23-.36l.05-.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M271.09,110.53l-.14-.38h0a1.13,1.13,0,0,1-.39.33,1.14,1.14,0,0,1-.52.09.88.88,0,0,1-.62-.22.84.84,0,0,1-.22-.64.7.7,0,0,1,.3-.64,1.75,1.75,0,0,1,.92-.23h.47v-.12a.37.37,0,0,0-.31-.42h-.12a2,2,0,0,0-.76.2l-.25-.5a2.18,2.18,0,0,1,1-.25,1.3,1.3,0,0,1,.85.24.92.92,0,0,1,.29.73v1.82Zm-.22-1.27h-.29a1,1,0,0,0-.48.12.34.34,0,0,0-.16.32c0,.21.12.32.36.32a.56.56,0,0,0,.41-.15.48.48,0,0,0,.16-.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M273.9,107.74h.25l-.06.69h-.22a.78.78,0,0,0-.55.18.68.68,0,0,0-.2.52v1.39h-.74V107.8h.56l.11.45h0a1,1,0,0,1,.34-.37A.84.84,0,0,1,273.9,107.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M275.88,110.57a1.47,1.47,0,0,1-1-.36,1.37,1.37,0,0,1-.37-1,1.47,1.47,0,0,1,.34-1.06,1.22,1.22,0,0,1,.95-.38,1.2,1.2,0,0,1,.9.33,1.23,1.23,0,0,1,.32.91v.37h-1.76a.75.75,0,0,0,.19.49.66.66,0,0,0,.5.18,1.77,1.77,0,0,0,.46,0,2.54,2.54,0,0,0,.46-.17v.58a1.5,1.5,0,0,1-.42.15A2.73,2.73,0,0,1,275.88,110.57Zm-.1-2.3a.46.46,0,0,0-.37.15.67.67,0,0,0-.16.43h1.05a.66.66,0,0,0-.15-.43A.48.48,0,0,0,275.78,108.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M279.33,110.53l-.14-.38h0a1.13,1.13,0,0,1-.39.33,1.14,1.14,0,0,1-.52.09.87.87,0,0,1-.61-.22.8.8,0,0,1-.23-.64.7.7,0,0,1,.3-.64,1.75,1.75,0,0,1,.92-.23h.47v-.12a.37.37,0,0,0-.31-.42h-.11a1.87,1.87,0,0,0-.77.2l-.25-.5a2.12,2.12,0,0,1,1.05-.25,1.26,1.26,0,0,1,.84.24.87.87,0,0,1,.29.73v1.82Zm-.22-1.27h-.28a1,1,0,0,0-.49.12.39.39,0,0,0-.16.32c0,.21.12.32.37.32a.56.56,0,0,0,.41-.15.51.51,0,0,0,.15-.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M283.65,110.53l-.14-.38h0a1.13,1.13,0,0,1-.39.33,1.14,1.14,0,0,1-.52.09.77.77,0,0,1-.84-.69.49.49,0,0,1,0-.17.7.7,0,0,1,.3-.64,1.75,1.75,0,0,1,.92-.23h.47v-.12a.37.37,0,0,0-.31-.42H283a1.87,1.87,0,0,0-.77.2L282,108a2.12,2.12,0,0,1,1.05-.25,1.31,1.31,0,0,1,.84.24.92.92,0,0,1,.29.73v1.82Zm-.22-1.27h-.29a1,1,0,0,0-.48.12.39.39,0,0,0-.16.32c0,.21.12.32.36.32a.6.6,0,0,0,.42-.15.51.51,0,0,0,.15-.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M287.46,110.53h-.75v-1.6a.75.75,0,0,0-.1-.44.38.38,0,0,0-.34-.15.52.52,0,0,0-.45.21,1.26,1.26,0,0,0-.14.69v1.29h-.74V107.8h.57l.1.34h0a.74.74,0,0,1,.34-.29,1.25,1.25,0,0,1,.5-.11,1,1,0,0,1,.72.26,1,1,0,0,1,.25.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M289.09,110.57a.91.91,0,0,1-.76-.37,2,2,0,0,1,0-2,.91.91,0,0,1,.77-.38.93.93,0,0,1,.79.4h0a2.48,2.48,0,0,1-.06-.54v-.87h.75v3.8H290l-.14-.36h0A.82.82,0,0,1,289.09,110.57Zm.26-.59a.48.48,0,0,0,.42-.17.84.84,0,0,0,.14-.56v-.08a1.14,1.14,0,0,0-.13-.63.47.47,0,0,0-.44-.19.42.42,0,0,0-.39.21,1.2,1.2,0,0,0-.14.62,1.13,1.13,0,0,0,.14.6.47.47,0,0,0,.4.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M263.37,117.57a1.47,1.47,0,0,1-1-.36,1.37,1.37,0,0,1-.37-1,1.47,1.47,0,0,1,.34-1.06,1.25,1.25,0,0,1,1-.38,1.2,1.2,0,0,1,.9.33,1.23,1.23,0,0,1,.32.91v.37H262.8a.73.73,0,0,0,.19.49.68.68,0,0,0,.49.18,2,2,0,0,0,.93-.22v.58a1.5,1.5,0,0,1-.42.15A2.57,2.57,0,0,1,263.37,117.57Zm-.11-2.3a.48.48,0,0,0-.37.15.66.66,0,0,0-.15.43h1a.6.6,0,0,0-.14-.43A.49.49,0,0,0,263.26,115.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M265.65,116.13l-.88-1.33h.84l.53.86.54-.86h.84l-.89,1.33.93,1.4h-.84l-.58-.94-.57.94h-.85Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M269.13,117a1.85,1.85,0,0,0,.47-.08v.55a1.62,1.62,0,0,1-.69.12.86.86,0,0,1-.65-.22,1,1,0,0,1-.2-.68v-1.32h-.36V115l.41-.25.22-.58h.47v.59h.77v.55h-.77v1.32a.3.3,0,0,0,.09.24A.38.38,0,0,0,269.13,117Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M271.39,117.57a1.47,1.47,0,0,1-1-.36,1.41,1.41,0,0,1-.37-1,1.51,1.51,0,0,1,.35-1.06,1.38,1.38,0,0,1,1.85-.05,1.27,1.27,0,0,1,.32.91v.37h-1.76a.73.73,0,0,0,.19.49.64.64,0,0,0,.49.18,1.85,1.85,0,0,0,.47,0,2.2,2.2,0,0,0,.45-.17v.58a2,2,0,0,1-.41.15A2.83,2.83,0,0,1,271.39,117.57Zm-.11-2.3a.46.46,0,0,0-.37.15.66.66,0,0,0-.15.43h1a.6.6,0,0,0-.14-.43A.49.49,0,0,0,271.28,115.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M275.62,117.53h-.74v-1.6a.76.76,0,0,0-.11-.44.39.39,0,0,0-.33-.15.47.47,0,0,0-.45.21,1.26,1.26,0,0,0-.14.69v1.29h-.75V114.8h.57l.1.34h0a.76.76,0,0,1,.35-.29,1.17,1.17,0,0,1,.49-.11,1,1,0,0,1,.73.26,1.07,1.07,0,0,1,.24.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M278.29,116.71a.73.73,0,0,1-.29.64,1.4,1.4,0,0,1-.87.22,2.18,2.18,0,0,1-.51,0,1.9,1.9,0,0,1-.39-.11v-.62a2.6,2.6,0,0,0,.47.16,1.76,1.76,0,0,0,.45.07c.27,0,.41-.08.41-.23a.27.27,0,0,0-.05-.15.76.76,0,0,0-.19-.12l-.35-.16a2.05,2.05,0,0,1-.46-.25.78.78,0,0,1-.22-.26.84.84,0,0,1-.07-.35.65.65,0,0,1,.29-.57,1.33,1.33,0,0,1,.8-.2,2.24,2.24,0,0,1,.95.22l-.22.54-.38-.15a1.15,1.15,0,0,0-.37,0c-.22,0-.33.06-.33.17a.27.27,0,0,0,.11.18,3.82,3.82,0,0,0,.46.21,1.92,1.92,0,0,1,.47.25.51.51,0,0,1,.22.26A.72.72,0,0,1,278.29,116.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M278.84,114.09c0-.24.14-.36.41-.36s.4.12.4.36a.34.34,0,0,1-.1.27.41.41,0,0,1-.3.1.36.36,0,0,1-.41-.31Zm.78,3.44h-.74V114.8h.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M282.88,116.16a1.46,1.46,0,0,1-.35,1,1.52,1.52,0,0,1-1.69.2,1.09,1.09,0,0,1-.46-.49,1.61,1.61,0,0,1-.16-.75,1.42,1.42,0,0,1,.34-1,1.32,1.32,0,0,1,1-.38,1.39,1.39,0,0,1,.69.18,1.09,1.09,0,0,1,.46.49A1.5,1.5,0,0,1,282.88,116.16Zm-1.89,0a1.19,1.19,0,0,0,.14.61.54.54,0,0,0,.76.1h0l.09-.09a1.18,1.18,0,0,0,.13-.61,1.09,1.09,0,0,0-.13-.61.49.49,0,0,0-.43-.21.46.46,0,0,0-.43.21,1.09,1.09,0,0,0-.13.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "font-black",
  d: "M286,117.53h-.75v-1.6a.75.75,0,0,0-.1-.44.38.38,0,0,0-.34-.15.47.47,0,0,0-.45.21,1.26,1.26,0,0,0-.14.69v1.29h-.74V114.8h.57l.1.34h0a.74.74,0,0,1,.34-.29,1.25,1.25,0,0,1,.5-.11,1,1,0,0,1,.72.26,1,1,0,0,1,.25.75Z"
})));

var SvgMapLarge = function SvgMapLarge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "rooms-history-map-large",
    "data-name": "Rooms history map",
    viewBox: "0 0 309.52 159.42",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMapLarge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map_large.63d97d02.svg";
export { ForwardRef as ReactComponent };